var _desc, _defs, _rect, _tspan, _tspan2, _tspan3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUntitled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 3.5.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "rgba(255,255,255,0)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 426.235 397.6161)",
    id: 655634
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5 0 0 0.5 73.915 102.3965)",
    id: "Logo"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,175,207)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1000.3, -1000.025)",
    d: "M 1704.94 1000 c 0 389.17 -315.47 704.64 -704.64 704.64 S 295.66 1389.17 295.66 1000 c 0 -2.49 0.01 -4.98 0.04 -7.46 v -0.35 c 0.03 -2.52 0.07 -5.04 0.13 -7.54 c 0.04 -2.01 0.08 -4.01 0.15 -6.01 c 0.04 -1.77 0.11 -3.55 0.18 -5.3 c 0 -0.34 0.01 -0.68 0.03 -1 c 0.06 -1.36 0.11 -2.73 0.17 -4.09 c 0.11 -2.53 0.24 -5.07 0.38 -7.6 c 0.07 -1.35 0.15 -2.7 0.24 -4.05 c 0.03 -0.62 0.07 -1.24 0.11 -1.84 c 0.06 -0.89 0.11 -1.76 0.17 -2.63 c 0.13 -1.84 0.25 -3.67 0.39 -5.52 c 0.18 -2.52 0.38 -5.02 0.61 -7.54 c 0.21 -2.5 0.44 -5.01 0.68 -7.51 c 0.18 -1.87 0.37 -3.73 0.56 -5.59 c 0.24 -2.29 0.49 -4.59 0.76 -6.88 c 0.11 -1.03 0.24 -2.05 0.35 -3.08 c 0.27 -2.29 0.56 -4.59 0.86 -6.88 c 0.25 -1.98 0.52 -3.97 0.79 -5.95 c 0.13 -0.9 0.25 -1.79 0.38 -2.67 c 0.28 -2.07 0.59 -4.14 0.9 -6.19 c 0.3 -2 0.61 -4 0.91 -5.98 c 0.55 -3.43 1.13 -6.87 1.73 -10.3 c 0.31 -1.8 0.63 -3.6 0.96 -5.4 c 0.03 -0.18 0.07 -0.35 0.1 -0.55 c 0.44 -2.38 0.89 -4.76 1.35 -7.12 c 0.46 -2.43 0.96 -4.85 1.45 -7.27 c 0.56 -2.76 1.15 -5.52 1.74 -8.27 c 0.45 -2.07 0.91 -4.12 1.38 -6.19 c 0.28 -1.25 0.58 -2.5 0.86 -3.76 h 0.01 c 0.87 -3.78 1.79 -7.57 2.73 -11.34 c 0.53 -2.12 1.08 -4.26 1.63 -6.37 c 1.24 -4.76 2.52 -9.48 3.86 -14.18 c 0.04 -0.15 0.08 -0.31 0.13 -0.46 c 0.63 -2.19 1.27 -4.39 1.91 -6.57 c 0.58 -1.98 1.17 -3.95 1.77 -5.92 c 0.25 -0.87 0.52 -1.73 0.8 -2.6 c 0.55 -1.83 1.13 -3.66 1.7 -5.47 c 0.75 -2.32 1.49 -4.63 2.25 -6.95 c 0.61 -1.86 1.24 -3.73 1.86 -5.59 c 0.27 -0.76 0.53 -1.53 0.79 -2.31 c 0.68 -1.96 1.35 -3.91 2.03 -5.85 c 0.01 -0.01 0.03 -0.04 0.03 -0.06 c 0.8 -2.29 1.63 -4.57 2.45 -6.85 c 0.1 -0.24 0.18 -0.49 0.27 -0.73 v -0.01 c 0.56 -1.51 1.11 -3.01 1.67 -4.5 c 0.2 -0.52 0.39 -1.06 0.59 -1.58 c 0.82 -2.17 1.63 -4.32 2.46 -6.47 c 0.04 -0.11 0.08 -0.21 0.13 -0.31 c 0.87 -2.27 1.76 -4.52 2.66 -6.75 c 0.9 -2.25 1.8 -4.49 2.73 -6.73 c 0.84 -2.04 1.69 -4.08 2.55 -6.12 c 1.03 -2.41 2.07 -4.81 3.11 -7.2 c 0.83 -1.9 1.66 -3.8 2.52 -5.68 c 0.65 -1.46 1.29 -2.93 1.97 -4.38 c 0.77 -1.74 1.58 -3.49 2.41 -5.22 c 0.91 -1.98 1.84 -3.97 2.79 -5.94 c 0.63 -1.35 1.28 -2.69 1.93 -4.02 c 0.55 -1.13 1.1 -2.25 1.65 -3.38 c 0.68 -1.36 1.35 -2.73 2.03 -4.09 c 3.28 -6.57 6.67 -13.09 10.14 -19.54 c 0.73 -1.38 1.48 -2.76 2.24 -4.12 c 0.76 -1.39 1.53 -2.79 2.31 -4.18 c 0.42 -0.77 0.86 -1.55 1.29 -2.32 c 0.84 -1.51 1.7 -3.01 2.56 -4.52 c 3.01 -5.28 6.08 -10.5 9.22 -15.67 c 0.76 -1.25 1.51 -2.49 2.28 -3.73 c 0.7 -1.15 1.41 -2.29 2.12 -3.43 c 1.25 -2.03 2.53 -4.05 3.81 -6.06 c 0.89 -1.39 1.77 -2.79 2.67 -4.16 c 0.37 -0.58 0.73 -1.15 1.11 -1.72 c 1.04 -1.62 2.11 -3.24 3.17 -4.84 c 1.21 -1.83 2.43 -3.64 3.66 -5.46 c 0.77 -1.14 1.53 -2.28 2.32 -3.41 c 1.59 -2.35 3.21 -4.67 4.84 -6.99 c 0.76 -1.1 1.53 -2.2 2.32 -3.28 c 0.2 -0.3 0.41 -0.59 0.62 -0.89 c 1.27 -1.79 2.55 -3.56 3.86 -5.33 c 1.31 -1.83 2.65 -3.64 4 -5.45 c 0.84 -1.15 1.69 -2.29 2.55 -3.43 c 1.2 -1.59 2.39 -3.18 3.62 -4.76 c 1.94 -2.56 3.93 -5.11 5.91 -7.64 c 5.02 -6.39 10.16 -12.69 15.39 -18.9 c 1.74 -2.07 3.5 -4.12 5.28 -6.18 c 129.21 -149.69 320.34 -244.43 533.6 -244.43 s 404.39 94.74 533.62 244.43 c 7.08 8.2 13.97 16.56 20.67 25.09 c 0.39 0.49 0.77 0.98 1.15 1.49 c 1.38 1.74 2.74 3.5 4.08 5.26 c 0.01 0.01 0.03 0.03 0.04 0.04 c 1.49 1.94 2.97 3.9 4.43 5.85 c 2.07 2.74 4.11 5.5 6.12 8.29 c 1.52 2.08 3.03 4.18 4.52 6.28 c 1.27 1.77 2.52 3.56 3.77 5.35 c 0.53 0.76 1.06 1.51 1.58 2.27 c 1.45 2.1 2.88 4.21 4.32 6.33 c 1.34 1.96 2.65 3.93 3.94 5.9 c 0.63 0.96 1.27 1.91 1.89 2.87 c 1.14 1.73 2.27 3.46 3.38 5.21 c 0.08 0.13 0.17 0.25 0.24 0.38 c 1.18 1.83 2.35 3.67 3.5 5.52 c 0.62 0.98 1.24 1.97 1.84 2.97 c 0.38 0.59 0.75 1.18 1.1 1.77 c 0.97 1.55 1.93 3.11 2.87 4.67 c 0.03 0.04 0.06 0.08 0.08 0.14 c 2.48 4.09 4.91 8.2 7.3 12.35 c 0.06 0.07 0.1 0.15 0.14 0.24 c 0.62 1.06 1.21 2.1 1.8 3.15 c 1 1.73 1.98 3.46 2.94 5.19 c 0.13 0.21 0.24 0.41 0.34 0.6 c 1.11 1.97 2.19 3.94 3.26 5.91 c 4.14 7.56 8.12 15.2 11.96 22.91 c 0.94 1.87 1.87 3.76 2.79 5.64 c 0.21 0.42 0.42 0.84 0.62 1.27 c 0.65 1.32 1.28 2.65 1.91 3.98 c 0.68 1.39 1.34 2.79 1.97 4.18 c 0.42 0.87 0.83 1.74 1.24 2.63 c 0.68 1.44 1.34 2.87 1.98 4.32 c 0.56 1.21 1.11 2.43 1.66 3.66 c 0.18 0.38 0.35 0.76 0.51 1.14 c 1.87 4.16 3.69 8.34 5.47 12.54 c 3.77 8.89 7.36 17.87 10.76 26.94 c 0.11 0.3 0.23 0.59 0.32 0.89 c 0.01 0 0.01 0.01 0.01 0.01 c 0.75 1.97 1.46 3.94 2.2 5.92 c 1.65 4.49 3.24 9.01 4.77 13.54 c 0.04 0.13 0.08 0.24 0.13 0.35 c 0.76 2.25 1.51 4.5 2.25 6.77 c 1.44 4.32 2.81 8.65 4.14 13 c 0.24 0.75 0.46 1.48 0.69 2.22 c 0.58 1.9 1.14 3.81 1.7 5.71 c 0.69 2.35 1.36 4.7 2.04 7.05 c 1.34 4.7 2.62 9.43 3.86 14.17 c 0.62 2.38 1.22 4.76 1.81 7.13 c 0.27 1.01 0.52 2.04 0.76 3.07 c 0.25 1.03 0.49 2.05 0.75 3.07 c 0.04 0.17 0.08 0.34 0.11 0.51 c 0.04 0.18 0.08 0.35 0.13 0.52 c 0.58 2.39 1.13 4.78 1.67 7.19 c 0.46 2.05 0.93 4.11 1.38 6.18 c 0.59 2.76 1.18 5.52 1.74 8.29 c 0.49 2.42 0.98 4.84 1.45 7.26 c 0.48 2.43 0.93 4.87 1.38 7.3 c 0.41 2.18 0.79 4.36 1.17 6.56 c 0.49 2.84 0.97 5.68 1.42 8.53 c 0.38 2.32 0.75 4.64 1.08 6.96 c 0.31 2.05 0.62 4.12 0.9 6.19 c 0.13 0.87 0.25 1.73 0.37 2.6 c 0.59 4.29 1.15 8.6 1.66 12.92 c 0.13 1.03 0.24 2.04 0.35 3.07 c 0.27 2.29 0.52 4.59 0.76 6.88 c 0.2 1.86 0.38 3.71 0.56 5.59 c 0.24 2.5 0.46 5.01 0.68 7.51 c 0.23 2.52 0.42 5.02 0.61 7.54 c 0.14 1.84 0.27 3.67 0.39 5.52 c 0.06 0.87 0.11 1.74 0.17 2.63 c 0.04 0.62 0.08 1.22 0.11 1.84 c 0.08 1.35 0.17 2.7 0.24 4.05 c 0.14 2.53 0.27 5.07 0.38 7.6 c 0.06 1.36 0.11 2.73 0.17 4.09 c 0.01 0.32 0.03 0.66 0.03 1 c 0.07 1.76 0.14 3.53 0.18 5.3 c 0.07 2 0.11 4 0.15 6.01 c 0.06 2.5 0.1 5.02 0.13 7.54 v 0.35 C 1704.93 995.02 1704.94 997.51 1704.94 1000 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5 0 0 0.5 73.915 163.504)",
    id: "Logo"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(35,31,32)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    transform: " translate(-1000.3, -1122.24)",
    d: "M 1704.94 1000 c 0 389.17 -315.47 704.64 -704.64 704.64 S 295.66 1389.17 295.66 1000 c 0 -2.49 0.01 -4.98 0.04 -7.46 v -0.35 c 0.03 -2.52 0.07 -5.04 0.13 -7.54 c 0.04 -2.01 0.08 -4.01 0.15 -6.01 c 0.04 -1.77 0.11 -3.55 0.18 -5.3 c 0 -0.34 0.01 -0.68 0.03 -1 c 0.06 -1.36 0.11 -2.73 0.17 -4.09 c 0.11 -2.53 0.24 -5.07 0.38 -7.6 c 0.07 -1.35 0.15 -2.7 0.24 -4.05 c 0.03 -0.62 0.07 -1.24 0.11 -1.84 c 0.06 -0.89 0.11 -1.76 0.17 -2.63 c 0.13 -1.84 0.25 -3.67 0.39 -5.52 c 0.18 -2.52 0.38 -5.02 0.61 -7.54 c 0.21 -2.5 0.44 -5.01 0.68 -7.51 c 0.18 -1.87 0.37 -3.73 0.56 -5.59 c 0.24 -2.29 0.49 -4.59 0.76 -6.88 c 0.11 -1.03 0.24 -2.05 0.35 -3.08 c 0.27 -2.29 0.56 -4.59 0.86 -6.88 c 0.25 -1.98 0.52 -3.97 0.79 -5.95 c 0.13 -0.9 0.25 -1.79 0.38 -2.67 c 0.28 -2.07 0.59 -4.14 0.9 -6.19 c 0.3 -2 0.61 -4 0.91 -5.98 c 0.55 -3.43 1.13 -6.87 1.73 -10.3 c 0.31 -1.8 0.63 -3.6 0.96 -5.4 c 0.03 -0.18 0.07 -0.35 0.1 -0.55 c 0.44 -2.38 0.89 -4.76 1.35 -7.12 c 0.46 -2.43 0.96 -4.85 1.45 -7.27 c 0.56 -2.76 1.15 -5.52 1.74 -8.27 c 0.45 -2.07 0.91 -4.12 1.38 -6.19 c 0.28 -1.25 0.58 -2.5 0.87 -3.76 c 0.87 -3.78 1.79 -7.57 2.73 -11.34 c 0.53 -2.12 1.08 -4.26 1.63 -6.37 c 1.24 -4.76 2.52 -9.48 3.86 -14.18 c 0.04 -0.15 0.08 -0.31 0.13 -0.46 c 0.63 -2.19 1.27 -4.39 1.91 -6.57 c 0.58 -1.98 1.17 -3.95 1.77 -5.92 c 0.25 -0.87 0.52 -1.73 0.8 -2.6 c 0.55 -1.83 1.13 -3.66 1.7 -5.47 c 0.75 -2.32 1.49 -4.63 2.25 -6.95 c 0.61 -1.86 1.24 -3.73 1.86 -5.59 c 0.27 -0.76 0.53 -1.53 0.79 -2.31 c 0.68 -1.96 1.35 -3.91 2.03 -5.85 c 0.01 -0.01 0.03 -0.04 0.03 -0.06 c 0.8 -2.29 1.63 -4.57 2.45 -6.85 c 0.1 -0.24 0.18 -0.49 0.27 -0.73 v -0.01 c 0.56 -1.51 1.11 -3.01 1.67 -4.5 c 0.2 -0.52 0.39 -1.06 0.59 -1.58 c 0.82 -2.17 1.63 -4.32 2.46 -6.47 c 0.04 -0.11 0.08 -0.21 0.13 -0.31 c 0.87 -2.27 1.76 -4.52 2.66 -6.75 c 0.9 -2.25 1.8 -4.49 2.73 -6.73 c 0.84 -2.04 1.69 -4.08 2.55 -6.12 c 1.03 -2.41 2.07 -4.81 3.11 -7.2 c 0.83 -1.9 1.66 -3.8 2.52 -5.68 c 0.65 -1.46 1.29 -2.93 1.97 -4.38 c 0.77 -1.74 1.58 -3.49 2.41 -5.22 c 0.91 -1.98 1.84 -3.97 2.79 -5.94 c 0.63 -1.35 1.28 -2.69 1.93 -4.02 c 0.55 -1.13 1.1 -2.25 1.65 -3.38 c 0.68 -1.36 1.35 -2.73 2.03 -4.09 c 3.28 -6.57 6.67 -13.09 10.14 -19.54 c 0.73 -1.38 1.48 -2.76 2.24 -4.12 c 0.76 -1.39 1.53 -2.79 2.31 -4.18 c 0.42 -0.77 0.86 -1.55 1.29 -2.32 c 0.84 -1.51 1.7 -3.01 2.56 -4.52 c 3.01 -5.28 6.08 -10.5 9.22 -15.67 c 0.76 -1.25 1.51 -2.49 2.28 -3.73 c 0.7 -1.15 1.41 -2.29 2.12 -3.43 c 1.25 -2.03 2.53 -4.05 3.81 -6.06 c 0.89 -1.39 1.77 -2.79 2.67 -4.16 c 0.37 -0.58 0.73 -1.15 1.11 -1.72 c 1.04 -1.62 2.11 -3.24 3.17 -4.84 c 1.21 -1.83 2.43 -3.64 3.66 -5.46 c 0.77 -1.14 1.53 -2.28 2.32 -3.41 c 1.59 -2.35 3.21 -4.67 4.84 -6.99 c 0.76 -1.1 1.53 -2.2 2.32 -3.28 c 0.2 -0.3 0.41 -0.59 0.62 -0.89 c 1.27 -1.79 2.55 -3.56 3.86 -5.33 c 1.31 -1.83 2.65 -3.64 4 -5.45 c 0.84 -1.15 1.69 -2.29 2.55 -3.43 c 1.2 -1.59 2.39 -3.18 3.62 -4.76 c 1.94 -2.56 3.93 -5.11 5.91 -7.64 c 5.02 -6.39 10.16 -12.69 15.39 -18.9 c 1.74 -2.07 3.5 -4.12 5.28 -6.18 c 62.28 60.81 130.95 108.47 204.37 143.53 c 10.55 5.04 21.2 9.82 31.95 14.34 c 83.58 35.33 172.05 54.56 261.37 58.81 c 11.96 0.56 23.93 0.87 35.91 0.9 c 9.01 -0.03 18 -0.2 26.99 -0.52 h 0.01 c 92.34 -3.36 183.91 -22.7 270.28 -59.19 c 13.65 -5.74 27.16 -11.9 40.49 -18.49 c 70.21 -34.63 135.99 -80.93 195.84 -139.38 c 7.08 8.2 13.97 16.56 20.67 25.09 c 0.39 0.49 0.77 0.98 1.15 1.49 c 1.38 1.74 2.74 3.5 4.08 5.26 c 0.01 0.01 0.03 0.03 0.04 0.04 c 1.49 1.94 2.97 3.9 4.43 5.85 c 2.07 2.74 4.11 5.5 6.12 8.29 c 1.52 2.08 3.03 4.18 4.52 6.28 c 1.27 1.77 2.52 3.56 3.77 5.35 c 0.53 0.76 1.06 1.51 1.58 2.27 c 1.45 2.1 2.88 4.21 4.32 6.33 c 1.34 1.96 2.65 3.93 3.94 5.9 c 0.63 0.96 1.27 1.91 1.89 2.87 c 1.14 1.73 2.27 3.46 3.38 5.21 c 0.08 0.13 0.17 0.25 0.24 0.38 c 1.18 1.83 2.35 3.67 3.5 5.52 c 0.62 0.98 1.24 1.97 1.84 2.97 c 0.38 0.59 0.75 1.18 1.1 1.77 c 0.97 1.55 1.93 3.11 2.87 4.67 c 0.03 0.04 0.06 0.08 0.08 0.14 c 2.48 4.09 4.91 8.2 7.3 12.35 c 0.06 0.07 0.1 0.15 0.14 0.24 c 0.62 1.06 1.21 2.1 1.8 3.15 c 1 1.73 1.98 3.46 2.94 5.19 c 0.13 0.21 0.24 0.41 0.34 0.6 c 1.11 1.97 2.19 3.94 3.26 5.91 c 4.14 7.56 8.12 15.2 11.96 22.91 c 0.94 1.87 1.87 3.76 2.79 5.64 c 0.21 0.42 0.42 0.84 0.62 1.27 c 0.65 1.32 1.28 2.65 1.91 3.98 c 0.68 1.39 1.34 2.79 1.97 4.18 c 0.42 0.87 0.83 1.74 1.24 2.63 c 0.68 1.44 1.34 2.87 1.98 4.32 c 0.56 1.21 1.11 2.43 1.66 3.66 c 0.18 0.38 0.35 0.76 0.51 1.14 c 1.87 4.16 3.69 8.34 5.47 12.54 c 3.77 8.89 7.36 17.87 10.76 26.94 c 0.11 0.3 0.23 0.59 0.32 0.89 c 0.01 0 0.01 0.01 0.01 0.01 c 0.75 1.97 1.46 3.94 2.2 5.92 c 1.63 4.49 3.22 9.01 4.77 13.54 c 0.04 0.13 0.08 0.24 0.13 0.35 c 0.76 2.25 1.51 4.5 2.25 6.77 c 1.42 4.32 2.8 8.65 4.14 13 c 0.24 0.75 0.46 1.48 0.69 2.22 c 0.58 1.9 1.14 3.81 1.7 5.71 c 0.69 2.35 1.36 4.7 2.04 7.05 c 1.34 4.7 2.62 9.43 3.86 14.17 c 0.62 2.38 1.22 4.76 1.81 7.13 c 0.27 1.01 0.52 2.04 0.76 3.07 c 0.24 1.01 0.49 2.04 0.73 3.07 c 0.04 0.17 0.1 0.34 0.13 0.51 c 0.04 0.18 0.08 0.35 0.13 0.52 c 0.58 2.39 1.13 4.78 1.67 7.19 c 0.46 2.05 0.93 4.11 1.38 6.18 c 0.59 2.76 1.18 5.52 1.74 8.29 c 0.49 2.42 0.98 4.84 1.45 7.26 c 0.48 2.43 0.93 4.87 1.38 7.3 c 0.41 2.18 0.79 4.36 1.17 6.56 c 0.49 2.84 0.97 5.68 1.42 8.53 c 0.38 2.32 0.75 4.64 1.08 6.96 c 0.31 2.05 0.62 4.12 0.9 6.19 c 0.13 0.87 0.25 1.73 0.37 2.6 c 0.59 4.29 1.15 8.6 1.66 12.92 c 0.13 1.03 0.24 2.04 0.35 3.07 c 0.27 2.29 0.52 4.59 0.76 6.88 c 0.2 1.86 0.38 3.71 0.56 5.59 c 0.24 2.5 0.46 5.01 0.68 7.51 c 0.23 2.52 0.42 5.02 0.61 7.54 c 0.14 1.84 0.27 3.67 0.39 5.52 c 0.06 0.87 0.11 1.74 0.17 2.63 c 0.04 0.62 0.08 1.22 0.11 1.84 c 0.08 1.35 0.17 2.7 0.24 4.05 c 0.14 2.53 0.27 5.07 0.38 7.6 c 0.06 1.36 0.11 2.73 0.17 4.09 c 0.01 0.32 0.03 0.66 0.03 1 c 0.07 1.76 0.14 3.53 0.18 5.3 c 0.07 2 0.11 4 0.15 6.01 c 0.06 2.5 0.1 5.02 0.13 7.54 v 0.35 C 1704.93 995.02 1704.94 997.51 1704.94 1000 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5 0 0 0.5 -47.7675 19.8107)",
    id: "Logo"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-756.935, -834.8534)",
    d: "M 1199.86 853.84 c -4.22 1.21 -8.43 2.45 -12.64 3.71 c -2.1 0.62 -4.19 1.27 -6.29 1.91 c -2.1 0.63 -4.19 1.28 -6.28 1.94 c -2.1 0.66 -4.19 1.32 -6.28 2 c -2.08 0.66 -4.16 1.34 -6.25 2.03 c -6.46 2.12 -12.89 4.31 -19.3 6.54 c -1.73 0.61 -3.46 1.21 -5.18 1.83 c -0.24 0.08 -0.48 0.17 -0.72 0.25 c -1.96 0.69 -3.9 1.39 -5.85 2.11 c -2.05 0.75 -4.12 1.51 -6.18 2.27 c -4.11 1.52 -8.19 3.07 -12.27 4.64 c -4.09 1.56 -8.16 3.17 -12.23 4.8 c -2.95 1.17 -5.91 2.36 -8.85 3.57 c -2.93 1.2 -5.85 2.41 -8.77 3.63 v 91.32 c -7.25 -4.7 -14.53 -9.3 -21.88 -13.82 c -4.29 -2.65 -8.58 -5.25 -12.9 -7.84 c -3.57 -2.12 -7.15 -4.22 -10.74 -6.32 c -8.79 -5.05 -17.64 -9.96 -26.56 -14.75 c -4.81 -2.59 -9.64 -5.14 -14.48 -7.64 c -12.35 -6.4 -24.82 -12.58 -37.41 -18.49 c -3.36 -1.59 -6.74 -3.15 -10.13 -4.7 c -3 -1.38 -5.99 -2.73 -9.01 -4.07 c -7.26 -3.25 -14.55 -6.42 -21.88 -9.48 c -2.41 -1.01 -4.83 -2.01 -7.25 -3.01 c -0.39 -0.15 -0.79 -0.32 -1.18 -0.48 c -3.05 -1.27 -6.12 -2.5 -9.19 -3.71 c -2.2 -0.89 -4.4 -1.76 -6.61 -2.62 c -2.21 -0.86 -4.42 -1.72 -6.63 -2.56 c -4.26 -1.65 -8.54 -3.26 -12.83 -4.83 c -2.48 -0.91 -4.95 -1.82 -7.43 -2.72 c -2.14 -0.77 -4.29 -1.55 -6.44 -2.29 c -4.47 -1.59 -8.96 -3.14 -13.45 -4.64 c -2.25 -0.77 -4.5 -1.52 -6.75 -2.25 c -2.25 -0.75 -4.5 -1.49 -6.77 -2.21 c -1.66 -0.55 -3.33 -1.07 -4.99 -1.59 c -3.1 -1 -6.2 -1.96 -9.33 -2.91 c -2 -0.62 -4.01 -1.22 -6.02 -1.83 c -0.04 -0.01 -0.07 -0.03 -0.1 -0.03 c -2.27 -0.68 -4.53 -1.35 -6.8 -2.01 c -2.28 -0.68 -4.57 -1.34 -6.85 -1.98 s -4.57 -1.29 -6.87 -1.93 c -47.66 -13.21 -96.42 -23.03 -146.05 -29.2 c -108.12 -13.62 -219.37 -9.88 -332.23 12.96 c 0.87 -3.78 1.79 -7.57 2.73 -11.34 c 0.53 -2.12 1.08 -4.26 1.63 -6.37 c 1.24 -4.76 2.52 -9.48 3.86 -14.18 c 0.04 -0.15 0.08 -0.31 0.13 -0.46 c 0.63 -2.19 1.27 -4.39 1.91 -6.57 c 0.58 -1.98 1.17 -3.95 1.77 -5.92 c 0.25 -0.87 0.52 -1.73 0.8 -2.6 c 0.55 -1.83 1.13 -3.66 1.7 -5.47 c 0.75 -2.32 1.49 -4.63 2.25 -6.95 c 0.61 -1.86 1.24 -3.73 1.86 -5.59 c 0.27 -0.76 0.53 -1.53 0.79 -2.31 c 0.68 -1.96 1.35 -3.91 2.03 -5.85 c 0.01 -0.01 0.03 -0.04 0.03 -0.06 c 0.8 -2.29 1.63 -4.57 2.45 -6.85 c 0.1 -0.24 0.18 -0.49 0.27 -0.73 v -0.01 c 96.03 -46.83 205.03 -71.67 314.08 -74.54 c 6.25 -0.18 12.51 -0.28 18.76 -0.31 c 110.03 -0.62 220.47 20.64 323.81 60.36 c 10.89 4.18 21.68 8.57 32.4 13.17 h 0.01 c 33.63 14.38 66.41 30.76 98.06 49.01 C 1150.92 820.63 1175.8 836.67 1199.86 853.84 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5 0 0 0.5 193.225 17.6876)",
    id: "Logo"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1238.92, -830.6074)",
    d: "M 1685.53 835.01 c 0 -0.01 -0.01 0 -0.01 0 c -112.49 -22.65 -223.39 -26.33 -331.17 -12.75 c -52.55 6.53 -104.16 17.17 -154.48 31.57 c -33.75 9.67 -66.95 21.05 -99.45 34.04 c -2.95 1.17 -5.91 2.36 -8.85 3.57 c -2.93 1.2 -5.85 2.41 -8.77 3.63 c -7.33 3.08 -14.63 6.23 -21.88 9.47 c -2.22 0.98 -4.45 1.98 -6.66 3 c -7.18 3.25 -14.32 6.58 -21.42 10 c -12.33 5.92 -24.52 12.09 -36.61 18.49 c -3.95 2.1 -7.89 4.21 -11.83 6.36 c -7.06 3.84 -14.08 7.75 -21.08 11.76 c -4.74 2.76 -9.46 5.56 -14.15 8.39 c -3.17 1.9 -6.33 3.83 -9.48 5.77 c -7.34 4.52 -14.65 9.13 -21.88 13.83 V 899.3 c -2.8 -1.18 -5.61 -2.34 -8.43 -3.49 c -3.05 -1.27 -6.12 -2.5 -9.19 -3.71 c -35.22 -14.06 -71.21 -26.23 -107.88 -36.4 c 26.68 -19.49 54.4 -37.57 82.94 -54.07 c 28.84 -16.63 58.63 -31.71 89.14 -45.15 c 10.09 -4.45 20.25 -8.71 30.49 -12.79 c 109.12 -43.53 226.48 -66.37 343.19 -64.51 c 3.4 0.04 6.81 0.11 10.22 0.21 c 108.31 2.86 216.58 27.38 312.14 73.62 c 0.01 0 0.01 0.01 0.01 0.01 c 0.75 1.97 1.46 3.94 2.2 5.92 c 1.65 4.49 3.24 9.01 4.77 13.54 c 0.04 0.13 0.08 0.24 0.13 0.35 c 0.76 2.25 1.51 4.5 2.25 6.77 c 1.44 4.32 2.81 8.65 4.14 13 c 0.24 0.75 0.46 1.48 0.69 2.22 c 0.58 1.9 1.14 3.81 1.7 5.71 c 0.69 2.35 1.36 4.7 2.04 7.05 c 1.34 4.7 2.62 9.43 3.86 14.17 c 0.62 2.38 1.22 4.76 1.81 7.13 C 1684.54 830.92 1685.03 832.97 1685.53 835.01 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5 0 0 0.5 73.9175 156.6715)",
    id: "Logo"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -60.615,
    y: -237.935,
    rx: 0,
    ry: 0,
    width: 121.23,
    height: 475.87
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5 0 0 0.5 73.915 49.4315)",
    id: "Logo"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -100.11,
    y: -23.455,
    rx: 0,
    ry: 0,
    width: 200.22,
    height: 46.91
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5 0 0 0.5 73.915 263.9115)",
    id: "Logo"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -100.11,
    y: -23.455,
    rx: 0,
    ry: 0,
    width: 200.22,
    height: 46.91
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5 0 0 0.5 73.915 45.789)",
    id: "Logo"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    cx: 0,
    cy: 0,
    r: 91.37
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5 0 0 0.5 73.915 45.789)",
    id: "Logo"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,175,207)",
      fillRule: "nonzero",
      opacity: 1
    },
    cx: 0,
    cy: 0,
    r: 57.82
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5 0 0 0.5 73.905 308.684)",
    id: "Logo"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1000.28, -1412.6)",
    d: "M 1100.41 1337.01 c -11.27 -11.89 -24.62 -21.77 -39.5 -29.04 c -6.87 -3.38 -14.07 -6.19 -21.53 -8.37 c -12.4 -3.67 -25.51 -5.63 -39.09 -5.63 s -26.69 1.96 -39.09 5.63 c -7.46 2.2 -14.66 5.01 -21.53 8.39 c -14.87 7.27 -28.24 17.15 -39.5 29.04 c -23.44 24.72 -37.84 58.12 -37.84 94.89 c 0 39 16.18 74.22 42.21 99.31 v -116.21 c 0 -33.64 17.43 -56.42 43.74 -68.51 c 5.39 -2.48 11.14 -4.52 17.19 -6.09 c 10.79 -2.83 22.53 -4.24 34.8 -4.24 s 24.02 1.41 34.81 4.24 c 6.05 1.58 11.8 3.62 17.18 6.09 c 26.31 12.09 43.76 34.87 43.76 68.51 v 116.21 c 26.03 -25.09 42.21 -60.31 42.21 -99.31 C 1138.26 1395.15 1123.88 1361.73 1100.41 1337.01 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5 0 0 0.5 73.92 291.239)",
    id: "Logo"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    points: "-95.74,37.3 -43.24,-31.2 43.23,-31.2 95.74,37.3 95.74,-37.3 -95.74,-37.3 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5 0 0 0.5 73.92 359.944)",
    id: "Logo"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    transform: " translate(-1000.31, -1515.12)",
    d: "M 1053.29 1563.92 c 0 29.26 -23.72 52.98 -52.98 52.98 s -52.98 -23.72 -52.98 -52.98 c 0 -29.26 52.98 -150.58 52.98 -150.58 S 1053.29 1534.66 1053.29 1563.92 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5 0 0 0.5 254.75 -122.081)",
    id: "Logo"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1361.97, -551.07)",
    d: "M 1340.93 596.76 v -14.75 c 0 -11.6 9.44 -21.04 21.04 -21.04 c 11.6 0 21.04 9.44 21.04 21.04 v 14.75 v 12.85 h 20.12 v -12.85 v -14.75 v -89.48 h -20.12 v 54.17 c -6.17 -3.69 -13.35 -5.85 -21.04 -5.85 s -14.87 2.16 -21.04 5.85 v -54.17 h -20.12 v 89.48 v 14.75 v 12.85 h 20.12 V 596.76 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5 0 0 0.5 207.025 -122.046)",
    id: "Logo"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1266.52, -551.14)",
    d: "M 1280.99 589.64 c -21.23 0 -38.49 -17.27 -38.49 -38.5 c 0 -21.22 17.27 -38.49 38.49 -38.49 c 6 0 11.73 1.34 17.05 3.97 l 8.93 -18.03 c -8.12 -4.02 -16.86 -6.06 -25.98 -6.06 c -32.32 0 -58.61 26.29 -58.61 58.61 c 0 32.32 26.29 58.61 58.61 58.61 c 10.45 0 20.71 -2.79 29.67 -8.06 l -10.2 -17.34 C 1294.58 587.81 1287.85 589.64 1280.99 589.64 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5 0 0 0.5 161.385 -122.0435)",
    id: "Logo"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    points: "-10.06,-58.615 -36.81,-58.615 -36.81,-38.495 -10.06,-38.495 -10.06,58.615 10.06,58.615 10.06,-38.495 36.81,-38.495 36.81,-58.615 10.06,-58.615 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5 0 0 0.5 106.73 -122.046)",
    id: "Logo"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1065.93, -551.14)",
    d: "M 1065.93 492.53 c -32.32 0 -58.61 26.29 -58.61 58.61 c 0 32.32 26.29 58.61 58.61 58.61 c 32.32 0 58.61 -26.29 58.61 -58.61 C 1124.54 518.82 1098.25 492.53 1065.93 492.53 z M 1065.93 589.64 c -21.23 0 -38.49 -17.27 -38.49 -38.5 c 0 -21.22 17.27 -38.49 38.49 -38.49 c 21.23 0 38.49 17.27 38.49 38.49 C 1104.43 572.37 1087.16 589.64 1065.93 589.64 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5 0 0 0.5 48.3175 -122.0835)",
    id: "Logo"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-949.105, -551.065)",
    d: "M 949.1 492.53 c -10.44 0 -20.09 3.38 -27.98 9.06 v -9.06 H 901 v 48.1 v 5.4 v 63.57 h 20.12 v -63.57 v -5.4 c 0 -15.43 12.55 -27.99 27.98 -27.99 c 15.43 0 27.99 12.55 27.99 27.99 v 68.97 h 20.12 v -68.97 C 997.2 514.11 975.62 492.53 949.1 492.53 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5 0 0 0.5 -1.4 -122.046)",
    id: "Logo"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-849.67, -551.14)",
    d: "M 849.67 574.85 c 22.69 0 41.16 -18.46 41.16 -41.16 c 0 -22.69 -18.46 -41.16 -41.16 -41.16 c -7.69 0 -14.87 2.16 -21.04 5.85 v -5.85 h -20.12 v 117.22 h 20.12 V 569 C 834.8 572.69 841.98 574.85 849.67 574.85 z M 849.67 512.65 c 11.6 0 21.04 9.44 21.04 21.04 c 0 11.6 -9.44 21.04 -21.04 21.04 c -11.6 0 -21.04 -9.44 -21.04 -21.04 C 828.63 522.09 838.07 512.65 849.67 512.65 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5 0 0 0.5 -56.39 -122.046)",
    id: "Logo"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-739.69, -551.14)",
    d: "M 739.69 492.53 c -32.32 0 -58.61 26.29 -58.61 58.61 c 0 32.32 26.29 58.61 58.61 58.61 c 32.32 0 58.61 -26.29 58.61 -58.61 C 798.3 518.82 772.01 492.53 739.69 492.53 z M 739.69 589.64 c -21.23 0 -38.49 -17.27 -38.49 -38.5 c 0 -21.22 17.27 -38.49 38.49 -38.49 c 21.23 0 38.49 17.27 38.49 38.49 C 778.19 572.37 760.92 589.64 739.69 589.64 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5 0 0 0.5 -109.3925 -122.0435)",
    id: "Logo"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    points: "-10.065,-58.615 -36.815,-58.615 -36.815,-38.495 -10.065,-38.495 -10.065,58.615 10.055,58.615 10.055,-38.495 36.815,-38.495 36.815,-58.615 10.055,-58.615 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5 0 0 0.5 73.9175 102.384)",
    id: "SVGID_x5F_1_x5F_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1000.305, -1000)",
    d: "M 1679.62 1000 c 0 -375.17 -304.14 -679.31 -679.31 -679.31 S 320.99 624.83 320.99 1000 s 304.14 679.31 679.31 679.31 S 1679.62 1375.18 1679.62 1000 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5 0 0 0.5 -98.6801 -417.979)",
    style: {},
    id: "Logo"
  }, /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    fontFamily: "'BelleroseLight'",
    fontSize: 130,
    fontStyle: "normal",
    fontWeight: "normal",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      whiteSpace: "pre"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: -655.1099,
    y: 40.8382
  }, "Mechanical Services Inc.")))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5 0 0 0.5 300.62 -111.8885)",
    id: "text"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    transform: " translate(-1453.71, -571.455)",
    d: "M 1409.51 585.21 l 10.09 -9.08 c 7.93 -7.14 20.2 -6.5 27.34 1.43 c 7.14 7.93 6.5 20.2 -1.43 27.34 l -10.09 9.08 l -8.79 7.91 l 12.39 13.76 l 8.79 -7.91 l 10.09 -9.08 l 61.19 -55.1 l -12.39 -13.76 l -37.04 33.35 c -1.27 -6.49 -4.22 -12.73 -8.96 -17.99 c -4.74 -5.26 -10.64 -8.84 -16.95 -10.79 l 37.04 -33.35 l -12.39 -13.76 l -61.19 55.1 l -10.09 9.08 l -8.79 7.91 l 12.39 13.76 L 1409.51 585.21 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5 0 0 0.5 247.9155 -156.4073)",
    id: "text"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    transform: " translate(-1348.3009, -482.4175)",
    d: "M 1327.8 509.91 c -14.96 -12.56 -16.92 -34.94 -4.37 -49.91 c 12.55 -14.96 34.94 -16.92 49.9 -4.36 c 4.23 3.55 7.48 7.88 9.67 12.89 l 16.96 -7.43 c -3.35 -7.64 -8.3 -14.25 -14.73 -19.64 c -22.78 -19.12 -56.87 -16.13 -75.99 6.65 c -19.12 22.78 -16.14 56.87 6.65 75.99 c 7.37 6.18 16.25 10.29 25.69 11.87 l 3.07 -18.26 C 1338.46 516.66 1332.64 513.97 1327.8 509.91 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5 0 0 0.5 189.9775 -191.976)",
    id: "text"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    points: "0.205,-48.86 -22.625,-58.09 -29.555,-40.92 -6.725,-31.7 -40.205,51.15 -23.035,58.09 10.435,-24.76 33.265,-15.54 40.205,-32.71 17.375,-41.93 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5 0 0 0.5 114.3625 -207.4486)",
    id: "text"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    transform: " translate(-1081.1949, -380.335)",
    d: "M 1087.77 326.8 c -29.52 -3.62 -56.48 17.44 -60.11 46.96 c -3.62 29.52 17.44 56.48 46.96 60.11 c 29.52 3.62 56.48 -17.44 60.11 -46.96 C 1138.35 357.39 1117.28 330.43 1087.77 326.8 z M 1076.88 415.5 c -19.39 -2.38 -33.22 -20.09 -30.84 -39.48 c 2.38 -19.39 20.09 -33.22 39.48 -30.84 c 19.39 2.38 33.22 20.09 30.84 39.47 C 1113.97 404.04 1096.26 417.88 1076.88 415.5 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5 0 0 0.5 40.43 -206.2821)",
    id: "text"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    transform: " translate(-933.33, -382.668)",
    d: "M 926.77 326.67 c -9.54 1.17 -17.97 5.34 -24.54 11.41 l -1.02 -8.27 l -18.37 2.26 l 5.39 43.94 l 0.61 4.93 l 7.13 58.06 l 18.37 -2.26 l -7.13 -58.06 l -0.61 -4.93 c -1.73 -14.09 8.33 -26.97 22.42 -28.7 c 14.09 -1.73 26.97 8.33 28.7 22.42 l 7.73 62.99 l 18.37 -2.26 l -7.73 -62.99 C 973.12 340.98 950.99 323.69 926.77 326.67 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5 0 0 0.5 -32.5358 -191.2401)",
    id: "text"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    transform: " translate(-787.3983, -412.7517)",
    d: "M 807.3 427.26 c 19.36 -7.82 28.75 -29.94 20.93 -49.3 c -7.82 -19.36 -29.94 -28.75 -49.3 -20.93 c -6.56 2.65 -11.95 6.97 -15.94 12.24 l -2.02 -4.99 l -17.16 6.93 l 40.41 100.02 l 17.16 -6.93 l -14.05 -34.77 C 793.86 430.55 800.73 429.92 807.3 427.26 z M 785.86 374.2 c 9.9 -4 21.2 0.8 25.2 10.7 c 4 9.9 -0.8 21.21 -10.7 25.2 c -9.9 4 -21.21 -0.8 -25.21 -10.7 C 771.16 389.5 775.96 378.19 785.86 374.2 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5 0 0 0.5 -93.855 -161.7069)",
    id: "text"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    transform: " translate(-664.76, -471.8184)",
    d: "M 630.09 430.5 c -22.78 19.12 -25.76 53.2 -6.65 75.99 c 19.12 22.78 53.2 25.77 75.99 6.65 c 22.78 -19.12 25.76 -53.2 6.65 -75.99 C 686.96 414.36 652.87 411.38 630.09 430.5 z M 687.53 498.95 c -14.96 12.56 -37.35 10.6 -49.91 -4.37 c -12.55 -14.96 -10.6 -37.35 4.37 -49.9 c 14.96 -12.56 37.35 -10.6 49.9 4.37 C 704.45 464.01 702.49 486.39 687.53 498.95 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5 0 0 0.5 -155.0925 -118.796)",
    id: "text"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    points: "-38.045,-20.06 -54.515,-1.77 -40.755,10.62 -24.285,-7.68 42.125,52.12 54.515,38.36 -11.895,-21.43 4.585,-39.73 -9.175,-52.12 -25.655,-33.82 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5 0 0 0.5 73.915 102.3965)",
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(35,31,32)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    transform: " translate(-1000.3, -1000.025)",
    d: "M 1704.94 1000 c 0 389.17 -315.47 704.64 -704.64 704.64 S 295.66 1389.17 295.66 1000 c 0 -2.49 0.01 -4.98 0.04 -7.46 v -0.35 c 0.03 -2.52 0.07 -5.04 0.13 -7.54 c 0.04 -2.01 0.08 -4.01 0.15 -6.01 c 0.04 -1.77 0.11 -3.55 0.18 -5.3 c 0 -0.34 0.01 -0.68 0.03 -1 c 0.06 -1.36 0.11 -2.73 0.17 -4.09 c 0.11 -2.53 0.24 -5.07 0.38 -7.6 c 0.07 -1.35 0.15 -2.7 0.24 -4.05 c 0.03 -0.62 0.07 -1.24 0.11 -1.84 c 0.06 -0.89 0.11 -1.76 0.17 -2.63 c 0.13 -1.84 0.25 -3.67 0.39 -5.52 c 0.18 -2.52 0.38 -5.02 0.61 -7.54 c 0.21 -2.5 0.44 -5.01 0.68 -7.51 c 0.18 -1.87 0.37 -3.73 0.56 -5.59 c 0.24 -2.29 0.49 -4.59 0.76 -6.88 c 0.11 -1.03 0.24 -2.05 0.35 -3.08 c 0.27 -2.29 0.56 -4.59 0.86 -6.88 c 0.25 -1.98 0.52 -3.97 0.79 -5.95 c 0.13 -0.9 0.25 -1.79 0.38 -2.67 c 0.28 -2.07 0.59 -4.14 0.9 -6.19 c 0.3 -2 0.61 -4 0.91 -5.98 c 0.55 -3.43 1.13 -6.87 1.73 -10.3 c 0.31 -1.8 0.63 -3.6 0.96 -5.4 c 0.03 -0.18 0.07 -0.35 0.1 -0.55 c 0.44 -2.38 0.89 -4.76 1.35 -7.12 c 0.46 -2.43 0.96 -4.85 1.45 -7.27 c 0.56 -2.76 1.15 -5.52 1.74 -8.27 c 0.45 -2.07 0.91 -4.12 1.38 -6.19 c 0.28 -1.25 0.58 -2.5 0.86 -3.76 h 0.01 c 0.87 -3.78 1.79 -7.57 2.73 -11.34 c 0.53 -2.12 1.08 -4.26 1.63 -6.37 c 1.24 -4.76 2.52 -9.48 3.86 -14.18 c 0.04 -0.15 0.08 -0.31 0.13 -0.46 c 0.63 -2.19 1.27 -4.39 1.91 -6.57 c 0.58 -1.98 1.17 -3.95 1.77 -5.92 c 0.25 -0.87 0.52 -1.73 0.8 -2.6 c 0.55 -1.83 1.13 -3.66 1.7 -5.47 c 0.75 -2.32 1.49 -4.63 2.25 -6.95 c 0.61 -1.86 1.24 -3.73 1.86 -5.59 c 0.27 -0.76 0.53 -1.53 0.79 -2.31 c 0.68 -1.96 1.35 -3.91 2.03 -5.85 c 0.01 -0.01 0.03 -0.04 0.03 -0.06 c 0.8 -2.29 1.63 -4.57 2.45 -6.85 c 0.1 -0.24 0.18 -0.49 0.27 -0.73 v -0.01 c 0.56 -1.51 1.11 -3.01 1.67 -4.5 c 0.2 -0.52 0.39 -1.06 0.59 -1.58 c 0.82 -2.17 1.63 -4.32 2.46 -6.47 c 0.04 -0.11 0.08 -0.21 0.13 -0.31 c 0.87 -2.27 1.76 -4.52 2.66 -6.75 c 0.9 -2.25 1.8 -4.49 2.73 -6.73 c 0.84 -2.04 1.69 -4.08 2.55 -6.12 c 1.03 -2.41 2.07 -4.81 3.11 -7.2 c 0.83 -1.9 1.66 -3.8 2.52 -5.68 c 0.65 -1.46 1.29 -2.93 1.97 -4.38 c 0.77 -1.74 1.58 -3.49 2.41 -5.22 c 0.91 -1.98 1.84 -3.97 2.79 -5.94 c 0.63 -1.35 1.28 -2.69 1.93 -4.02 c 0.55 -1.13 1.1 -2.25 1.65 -3.38 c 0.68 -1.36 1.35 -2.73 2.03 -4.09 c 3.28 -6.57 6.67 -13.09 10.14 -19.54 c 0.73 -1.38 1.48 -2.76 2.24 -4.12 c 0.76 -1.39 1.53 -2.79 2.31 -4.18 c 0.42 -0.77 0.86 -1.55 1.29 -2.32 c 0.84 -1.51 1.7 -3.01 2.56 -4.52 c 3.01 -5.28 6.08 -10.5 9.22 -15.67 c 0.76 -1.25 1.51 -2.49 2.28 -3.73 c 0.7 -1.15 1.41 -2.29 2.12 -3.43 c 1.25 -2.03 2.53 -4.05 3.81 -6.06 c 0.89 -1.39 1.77 -2.79 2.67 -4.16 c 0.37 -0.58 0.73 -1.15 1.11 -1.72 c 1.04 -1.62 2.11 -3.24 3.17 -4.84 c 1.21 -1.83 2.43 -3.64 3.66 -5.46 c 0.77 -1.14 1.53 -2.28 2.32 -3.41 c 1.59 -2.35 3.21 -4.67 4.84 -6.99 c 0.76 -1.1 1.53 -2.2 2.32 -3.28 c 0.2 -0.3 0.41 -0.59 0.62 -0.89 c 1.27 -1.79 2.55 -3.56 3.86 -5.33 c 1.31 -1.83 2.65 -3.64 4 -5.45 c 0.84 -1.15 1.69 -2.29 2.55 -3.43 c 1.2 -1.59 2.39 -3.18 3.62 -4.76 c 1.94 -2.56 3.93 -5.11 5.91 -7.64 c 5.02 -6.39 10.16 -12.69 15.39 -18.9 c 1.74 -2.07 3.5 -4.12 5.28 -6.18 c 129.21 -149.69 320.34 -244.43 533.6 -244.43 s 404.39 94.74 533.62 244.43 c 7.08 8.2 13.97 16.56 20.67 25.09 c 0.39 0.49 0.77 0.98 1.15 1.49 c 1.38 1.74 2.74 3.5 4.08 5.26 c 0.01 0.01 0.03 0.03 0.04 0.04 c 1.49 1.94 2.97 3.9 4.43 5.85 c 2.07 2.74 4.11 5.5 6.12 8.29 c 1.52 2.08 3.03 4.18 4.52 6.28 c 1.27 1.77 2.52 3.56 3.77 5.35 c 0.53 0.76 1.06 1.51 1.58 2.27 c 1.45 2.1 2.88 4.21 4.32 6.33 c 1.34 1.96 2.65 3.93 3.94 5.9 c 0.63 0.96 1.27 1.91 1.89 2.87 c 1.14 1.73 2.27 3.46 3.38 5.21 c 0.08 0.13 0.17 0.25 0.24 0.38 c 1.18 1.83 2.35 3.67 3.5 5.52 c 0.62 0.98 1.24 1.97 1.84 2.97 c 0.38 0.59 0.75 1.18 1.1 1.77 c 0.97 1.55 1.93 3.11 2.87 4.67 c 0.03 0.04 0.06 0.08 0.08 0.14 c 2.48 4.09 4.91 8.2 7.3 12.35 c 0.06 0.07 0.1 0.15 0.14 0.24 c 0.62 1.06 1.21 2.1 1.8 3.15 c 1 1.73 1.98 3.46 2.94 5.19 c 0.13 0.21 0.24 0.41 0.34 0.6 c 1.11 1.97 2.19 3.94 3.26 5.91 c 4.14 7.56 8.12 15.2 11.96 22.91 c 0.94 1.87 1.87 3.76 2.79 5.64 c 0.21 0.42 0.42 0.84 0.62 1.27 c 0.65 1.32 1.28 2.65 1.91 3.98 c 0.68 1.39 1.34 2.79 1.97 4.18 c 0.42 0.87 0.83 1.74 1.24 2.63 c 0.68 1.44 1.34 2.87 1.98 4.32 c 0.56 1.21 1.11 2.43 1.66 3.66 c 0.18 0.38 0.35 0.76 0.51 1.14 c 1.87 4.16 3.69 8.34 5.47 12.54 c 3.77 8.89 7.36 17.87 10.76 26.94 c 0.11 0.3 0.23 0.59 0.32 0.89 c 0.01 0 0.01 0.01 0.01 0.01 c 0.75 1.97 1.46 3.94 2.2 5.92 c 1.65 4.49 3.24 9.01 4.77 13.54 c 0.04 0.13 0.08 0.24 0.13 0.35 c 0.76 2.25 1.51 4.5 2.25 6.77 c 1.44 4.32 2.81 8.65 4.14 13 c 0.24 0.75 0.46 1.48 0.69 2.22 c 0.58 1.9 1.14 3.81 1.7 5.71 c 0.69 2.35 1.36 4.7 2.04 7.05 c 1.34 4.7 2.62 9.43 3.86 14.17 c 0.62 2.38 1.22 4.76 1.81 7.13 c 0.27 1.01 0.52 2.04 0.76 3.07 c 0.25 1.03 0.49 2.05 0.75 3.07 c 0.04 0.17 0.08 0.34 0.11 0.51 c 0.04 0.18 0.08 0.35 0.13 0.52 c 0.58 2.39 1.13 4.78 1.67 7.19 c 0.46 2.05 0.93 4.11 1.38 6.18 c 0.59 2.76 1.18 5.52 1.74 8.29 c 0.49 2.42 0.98 4.84 1.45 7.26 c 0.48 2.43 0.93 4.87 1.38 7.3 c 0.41 2.18 0.79 4.36 1.17 6.56 c 0.49 2.84 0.97 5.68 1.42 8.53 c 0.38 2.32 0.75 4.64 1.08 6.96 c 0.31 2.05 0.62 4.12 0.9 6.19 c 0.13 0.87 0.25 1.73 0.37 2.6 c 0.59 4.29 1.15 8.6 1.66 12.92 c 0.13 1.03 0.24 2.04 0.35 3.07 c 0.27 2.29 0.52 4.59 0.76 6.88 c 0.2 1.86 0.38 3.71 0.56 5.59 c 0.24 2.5 0.46 5.01 0.68 7.51 c 0.23 2.52 0.42 5.02 0.61 7.54 c 0.14 1.84 0.27 3.67 0.39 5.52 c 0.06 0.87 0.11 1.74 0.17 2.63 c 0.04 0.62 0.08 1.22 0.11 1.84 c 0.08 1.35 0.17 2.7 0.24 4.05 c 0.14 2.53 0.27 5.07 0.38 7.6 c 0.06 1.36 0.11 2.73 0.17 4.09 c 0.01 0.32 0.03 0.66 0.03 1 c 0.07 1.76 0.14 3.53 0.18 5.3 c 0.07 2 0.11 4 0.15 6.01 c 0.06 2.5 0.1 5.02 0.13 7.54 v 0.35 C 1704.93 995.02 1704.94 997.51 1704.94 1000 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5 0 0 0.5 73.915 163.504)",
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(35,31,32)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    transform: " translate(-1000.3, -1122.24)",
    d: "M 1704.94 1000 c 0 389.17 -315.47 704.64 -704.64 704.64 S 295.66 1389.17 295.66 1000 c 0 -2.49 0.01 -4.98 0.04 -7.46 v -0.35 c 0.03 -2.52 0.07 -5.04 0.13 -7.54 c 0.04 -2.01 0.08 -4.01 0.15 -6.01 c 0.04 -1.77 0.11 -3.55 0.18 -5.3 c 0 -0.34 0.01 -0.68 0.03 -1 c 0.06 -1.36 0.11 -2.73 0.17 -4.09 c 0.11 -2.53 0.24 -5.07 0.38 -7.6 c 0.07 -1.35 0.15 -2.7 0.24 -4.05 c 0.03 -0.62 0.07 -1.24 0.11 -1.84 c 0.06 -0.89 0.11 -1.76 0.17 -2.63 c 0.13 -1.84 0.25 -3.67 0.39 -5.52 c 0.18 -2.52 0.38 -5.02 0.61 -7.54 c 0.21 -2.5 0.44 -5.01 0.68 -7.51 c 0.18 -1.87 0.37 -3.73 0.56 -5.59 c 0.24 -2.29 0.49 -4.59 0.76 -6.88 c 0.11 -1.03 0.24 -2.05 0.35 -3.08 c 0.27 -2.29 0.56 -4.59 0.86 -6.88 c 0.25 -1.98 0.52 -3.97 0.79 -5.95 c 0.13 -0.9 0.25 -1.79 0.38 -2.67 c 0.28 -2.07 0.59 -4.14 0.9 -6.19 c 0.3 -2 0.61 -4 0.91 -5.98 c 0.55 -3.43 1.13 -6.87 1.73 -10.3 c 0.31 -1.8 0.63 -3.6 0.96 -5.4 c 0.03 -0.18 0.07 -0.35 0.1 -0.55 c 0.44 -2.38 0.89 -4.76 1.35 -7.12 c 0.46 -2.43 0.96 -4.85 1.45 -7.27 c 0.56 -2.76 1.15 -5.52 1.74 -8.27 c 0.45 -2.07 0.91 -4.12 1.38 -6.19 c 0.28 -1.25 0.58 -2.5 0.87 -3.76 c 0.87 -3.78 1.79 -7.57 2.73 -11.34 c 0.53 -2.12 1.08 -4.26 1.63 -6.37 c 1.24 -4.76 2.52 -9.48 3.86 -14.18 c 0.04 -0.15 0.08 -0.31 0.13 -0.46 c 0.63 -2.19 1.27 -4.39 1.91 -6.57 c 0.58 -1.98 1.17 -3.95 1.77 -5.92 c 0.25 -0.87 0.52 -1.73 0.8 -2.6 c 0.55 -1.83 1.13 -3.66 1.7 -5.47 c 0.75 -2.32 1.49 -4.63 2.25 -6.95 c 0.61 -1.86 1.24 -3.73 1.86 -5.59 c 0.27 -0.76 0.53 -1.53 0.79 -2.31 c 0.68 -1.96 1.35 -3.91 2.03 -5.85 c 0.01 -0.01 0.03 -0.04 0.03 -0.06 c 0.8 -2.29 1.63 -4.57 2.45 -6.85 c 0.1 -0.24 0.18 -0.49 0.27 -0.73 v -0.01 c 0.56 -1.51 1.11 -3.01 1.67 -4.5 c 0.2 -0.52 0.39 -1.06 0.59 -1.58 c 0.82 -2.17 1.63 -4.32 2.46 -6.47 c 0.04 -0.11 0.08 -0.21 0.13 -0.31 c 0.87 -2.27 1.76 -4.52 2.66 -6.75 c 0.9 -2.25 1.8 -4.49 2.73 -6.73 c 0.84 -2.04 1.69 -4.08 2.55 -6.12 c 1.03 -2.41 2.07 -4.81 3.11 -7.2 c 0.83 -1.9 1.66 -3.8 2.52 -5.68 c 0.65 -1.46 1.29 -2.93 1.97 -4.38 c 0.77 -1.74 1.58 -3.49 2.41 -5.22 c 0.91 -1.98 1.84 -3.97 2.79 -5.94 c 0.63 -1.35 1.28 -2.69 1.93 -4.02 c 0.55 -1.13 1.1 -2.25 1.65 -3.38 c 0.68 -1.36 1.35 -2.73 2.03 -4.09 c 3.28 -6.57 6.67 -13.09 10.14 -19.54 c 0.73 -1.38 1.48 -2.76 2.24 -4.12 c 0.76 -1.39 1.53 -2.79 2.31 -4.18 c 0.42 -0.77 0.86 -1.55 1.29 -2.32 c 0.84 -1.51 1.7 -3.01 2.56 -4.52 c 3.01 -5.28 6.08 -10.5 9.22 -15.67 c 0.76 -1.25 1.51 -2.49 2.28 -3.73 c 0.7 -1.15 1.41 -2.29 2.12 -3.43 c 1.25 -2.03 2.53 -4.05 3.81 -6.06 c 0.89 -1.39 1.77 -2.79 2.67 -4.16 c 0.37 -0.58 0.73 -1.15 1.11 -1.72 c 1.04 -1.62 2.11 -3.24 3.17 -4.84 c 1.21 -1.83 2.43 -3.64 3.66 -5.46 c 0.77 -1.14 1.53 -2.28 2.32 -3.41 c 1.59 -2.35 3.21 -4.67 4.84 -6.99 c 0.76 -1.1 1.53 -2.2 2.32 -3.28 c 0.2 -0.3 0.41 -0.59 0.62 -0.89 c 1.27 -1.79 2.55 -3.56 3.86 -5.33 c 1.31 -1.83 2.65 -3.64 4 -5.45 c 0.84 -1.15 1.69 -2.29 2.55 -3.43 c 1.2 -1.59 2.39 -3.18 3.62 -4.76 c 1.94 -2.56 3.93 -5.11 5.91 -7.64 c 5.02 -6.39 10.16 -12.69 15.39 -18.9 c 1.74 -2.07 3.5 -4.12 5.28 -6.18 c 62.28 60.81 130.95 108.47 204.37 143.53 c 10.55 5.04 21.2 9.82 31.95 14.34 c 83.58 35.33 172.05 54.56 261.37 58.81 c 11.96 0.56 23.93 0.87 35.91 0.9 c 9.01 -0.03 18 -0.2 26.99 -0.52 h 0.01 c 92.34 -3.36 183.91 -22.7 270.28 -59.19 c 13.65 -5.74 27.16 -11.9 40.49 -18.49 c 70.21 -34.63 135.99 -80.93 195.84 -139.38 c 7.08 8.2 13.97 16.56 20.67 25.09 c 0.39 0.49 0.77 0.98 1.15 1.49 c 1.38 1.74 2.74 3.5 4.08 5.26 c 0.01 0.01 0.03 0.03 0.04 0.04 c 1.49 1.94 2.97 3.9 4.43 5.85 c 2.07 2.74 4.11 5.5 6.12 8.29 c 1.52 2.08 3.03 4.18 4.52 6.28 c 1.27 1.77 2.52 3.56 3.77 5.35 c 0.53 0.76 1.06 1.51 1.58 2.27 c 1.45 2.1 2.88 4.21 4.32 6.33 c 1.34 1.96 2.65 3.93 3.94 5.9 c 0.63 0.96 1.27 1.91 1.89 2.87 c 1.14 1.73 2.27 3.46 3.38 5.21 c 0.08 0.13 0.17 0.25 0.24 0.38 c 1.18 1.83 2.35 3.67 3.5 5.52 c 0.62 0.98 1.24 1.97 1.84 2.97 c 0.38 0.59 0.75 1.18 1.1 1.77 c 0.97 1.55 1.93 3.11 2.87 4.67 c 0.03 0.04 0.06 0.08 0.08 0.14 c 2.48 4.09 4.91 8.2 7.3 12.35 c 0.06 0.07 0.1 0.15 0.14 0.24 c 0.62 1.06 1.21 2.1 1.8 3.15 c 1 1.73 1.98 3.46 2.94 5.19 c 0.13 0.21 0.24 0.41 0.34 0.6 c 1.11 1.97 2.19 3.94 3.26 5.91 c 4.14 7.56 8.12 15.2 11.96 22.91 c 0.94 1.87 1.87 3.76 2.79 5.64 c 0.21 0.42 0.42 0.84 0.62 1.27 c 0.65 1.32 1.28 2.65 1.91 3.98 c 0.68 1.39 1.34 2.79 1.97 4.18 c 0.42 0.87 0.83 1.74 1.24 2.63 c 0.68 1.44 1.34 2.87 1.98 4.32 c 0.56 1.21 1.11 2.43 1.66 3.66 c 0.18 0.38 0.35 0.76 0.51 1.14 c 1.87 4.16 3.69 8.34 5.47 12.54 c 3.77 8.89 7.36 17.87 10.76 26.94 c 0.11 0.3 0.23 0.59 0.32 0.89 c 0.01 0 0.01 0.01 0.01 0.01 c 0.75 1.97 1.46 3.94 2.2 5.92 c 1.63 4.49 3.22 9.01 4.77 13.54 c 0.04 0.13 0.08 0.24 0.13 0.35 c 0.76 2.25 1.51 4.5 2.25 6.77 c 1.42 4.32 2.8 8.65 4.14 13 c 0.24 0.75 0.46 1.48 0.69 2.22 c 0.58 1.9 1.14 3.81 1.7 5.71 c 0.69 2.35 1.36 4.7 2.04 7.05 c 1.34 4.7 2.62 9.43 3.86 14.17 c 0.62 2.38 1.22 4.76 1.81 7.13 c 0.27 1.01 0.52 2.04 0.76 3.07 c 0.24 1.01 0.49 2.04 0.73 3.07 c 0.04 0.17 0.1 0.34 0.13 0.51 c 0.04 0.18 0.08 0.35 0.13 0.52 c 0.58 2.39 1.13 4.78 1.67 7.19 c 0.46 2.05 0.93 4.11 1.38 6.18 c 0.59 2.76 1.18 5.52 1.74 8.29 c 0.49 2.42 0.98 4.84 1.45 7.26 c 0.48 2.43 0.93 4.87 1.38 7.3 c 0.41 2.18 0.79 4.36 1.17 6.56 c 0.49 2.84 0.97 5.68 1.42 8.53 c 0.38 2.32 0.75 4.64 1.08 6.96 c 0.31 2.05 0.62 4.12 0.9 6.19 c 0.13 0.87 0.25 1.73 0.37 2.6 c 0.59 4.29 1.15 8.6 1.66 12.92 c 0.13 1.03 0.24 2.04 0.35 3.07 c 0.27 2.29 0.52 4.59 0.76 6.88 c 0.2 1.86 0.38 3.71 0.56 5.59 c 0.24 2.5 0.46 5.01 0.68 7.51 c 0.23 2.52 0.42 5.02 0.61 7.54 c 0.14 1.84 0.27 3.67 0.39 5.52 c 0.06 0.87 0.11 1.74 0.17 2.63 c 0.04 0.62 0.08 1.22 0.11 1.84 c 0.08 1.35 0.17 2.7 0.24 4.05 c 0.14 2.53 0.27 5.07 0.38 7.6 c 0.06 1.36 0.11 2.73 0.17 4.09 c 0.01 0.32 0.03 0.66 0.03 1 c 0.07 1.76 0.14 3.53 0.18 5.3 c 0.07 2 0.11 4 0.15 6.01 c 0.06 2.5 0.1 5.02 0.13 7.54 v 0.35 C 1704.93 995.02 1704.94 997.51 1704.94 1000 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5 0 0 0.5 -47.7675 19.8107)",
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    transform: " translate(-756.935, -834.8534)",
    d: "M 1199.86 853.84 c -4.22 1.21 -8.43 2.45 -12.64 3.71 c -2.1 0.62 -4.19 1.27 -6.29 1.91 c -2.1 0.63 -4.19 1.28 -6.28 1.94 c -2.1 0.66 -4.19 1.32 -6.28 2 c -2.08 0.66 -4.16 1.34 -6.25 2.03 c -6.46 2.12 -12.89 4.31 -19.3 6.54 c -1.73 0.61 -3.46 1.21 -5.18 1.83 c -0.24 0.08 -0.48 0.17 -0.72 0.25 c -1.96 0.69 -3.9 1.39 -5.85 2.11 c -2.05 0.75 -4.12 1.51 -6.18 2.27 c -4.11 1.52 -8.19 3.07 -12.27 4.64 c -4.09 1.56 -8.16 3.17 -12.23 4.8 c -2.95 1.17 -5.91 2.36 -8.85 3.57 c -2.93 1.2 -5.85 2.41 -8.77 3.63 v 91.32 c -7.25 -4.7 -14.53 -9.3 -21.88 -13.82 c -4.29 -2.65 -8.58 -5.25 -12.9 -7.84 c -3.57 -2.12 -7.15 -4.22 -10.74 -6.32 c -8.79 -5.05 -17.64 -9.96 -26.56 -14.75 c -4.81 -2.59 -9.64 -5.14 -14.48 -7.64 c -12.35 -6.4 -24.82 -12.58 -37.41 -18.49 c -3.36 -1.59 -6.74 -3.15 -10.13 -4.7 c -3 -1.38 -5.99 -2.73 -9.01 -4.07 c -7.26 -3.25 -14.55 -6.42 -21.88 -9.48 c -2.41 -1.01 -4.83 -2.01 -7.25 -3.01 c -0.39 -0.15 -0.79 -0.32 -1.18 -0.48 c -3.05 -1.27 -6.12 -2.5 -9.19 -3.71 c -2.2 -0.89 -4.4 -1.76 -6.61 -2.62 c -2.21 -0.86 -4.42 -1.72 -6.63 -2.56 c -4.26 -1.65 -8.54 -3.26 -12.83 -4.83 c -2.48 -0.91 -4.95 -1.82 -7.43 -2.72 c -2.14 -0.77 -4.29 -1.55 -6.44 -2.29 c -4.47 -1.59 -8.96 -3.14 -13.45 -4.64 c -2.25 -0.77 -4.5 -1.52 -6.75 -2.25 c -2.25 -0.75 -4.5 -1.49 -6.77 -2.21 c -1.66 -0.55 -3.33 -1.07 -4.99 -1.59 c -3.1 -1 -6.2 -1.96 -9.33 -2.91 c -2 -0.62 -4.01 -1.22 -6.02 -1.83 c -0.04 -0.01 -0.07 -0.03 -0.1 -0.03 c -2.27 -0.68 -4.53 -1.35 -6.8 -2.01 c -2.28 -0.68 -4.57 -1.34 -6.85 -1.98 s -4.57 -1.29 -6.87 -1.93 c -47.66 -13.21 -96.42 -23.03 -146.05 -29.2 c -108.12 -13.62 -219.37 -9.88 -332.23 12.96 c 0.87 -3.78 1.79 -7.57 2.73 -11.34 c 0.53 -2.12 1.08 -4.26 1.63 -6.37 c 1.24 -4.76 2.52 -9.48 3.86 -14.18 c 0.04 -0.15 0.08 -0.31 0.13 -0.46 c 0.63 -2.19 1.27 -4.39 1.91 -6.57 c 0.58 -1.98 1.17 -3.95 1.77 -5.92 c 0.25 -0.87 0.52 -1.73 0.8 -2.6 c 0.55 -1.83 1.13 -3.66 1.7 -5.47 c 0.75 -2.32 1.49 -4.63 2.25 -6.95 c 0.61 -1.86 1.24 -3.73 1.86 -5.59 c 0.27 -0.76 0.53 -1.53 0.79 -2.31 c 0.68 -1.96 1.35 -3.91 2.03 -5.85 c 0.01 -0.01 0.03 -0.04 0.03 -0.06 c 0.8 -2.29 1.63 -4.57 2.45 -6.85 c 0.1 -0.24 0.18 -0.49 0.27 -0.73 v -0.01 c 96.03 -46.83 205.03 -71.67 314.08 -74.54 c 6.25 -0.18 12.51 -0.28 18.76 -0.31 c 110.03 -0.62 220.47 20.64 323.81 60.36 c 10.89 4.18 21.68 8.57 32.4 13.17 h 0.01 c 33.63 14.38 66.41 30.76 98.06 49.01 C 1150.92 820.63 1175.8 836.67 1199.86 853.84 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5 0 0 0.5 193.225 17.6876)",
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    transform: " translate(-1238.92, -830.6074)",
    d: "M 1685.53 835.01 c 0 -0.01 -0.01 0 -0.01 0 c -112.49 -22.65 -223.39 -26.33 -331.17 -12.75 c -52.55 6.53 -104.16 17.17 -154.48 31.57 c -33.75 9.67 -66.95 21.05 -99.45 34.04 c -2.95 1.17 -5.91 2.36 -8.85 3.57 c -2.93 1.2 -5.85 2.41 -8.77 3.63 c -7.33 3.08 -14.63 6.23 -21.88 9.47 c -2.22 0.98 -4.45 1.98 -6.66 3 c -7.18 3.25 -14.32 6.58 -21.42 10 c -12.33 5.92 -24.52 12.09 -36.61 18.49 c -3.95 2.1 -7.89 4.21 -11.83 6.36 c -7.06 3.84 -14.08 7.75 -21.08 11.76 c -4.74 2.76 -9.46 5.56 -14.15 8.39 c -3.17 1.9 -6.33 3.83 -9.48 5.77 c -7.34 4.52 -14.65 9.13 -21.88 13.83 V 899.3 c -2.8 -1.18 -5.61 -2.34 -8.43 -3.49 c -3.05 -1.27 -6.12 -2.5 -9.19 -3.71 c -35.22 -14.06 -71.21 -26.23 -107.88 -36.4 c 26.68 -19.49 54.4 -37.57 82.94 -54.07 c 28.84 -16.63 58.63 -31.71 89.14 -45.15 c 10.09 -4.45 20.25 -8.71 30.49 -12.79 c 109.12 -43.53 226.48 -66.37 343.19 -64.51 c 3.4 0.04 6.81 0.11 10.22 0.21 c 108.31 2.86 216.58 27.38 312.14 73.62 c 0.01 0 0.01 0.01 0.01 0.01 c 0.75 1.97 1.46 3.94 2.2 5.92 c 1.65 4.49 3.24 9.01 4.77 13.54 c 0.04 0.13 0.08 0.24 0.13 0.35 c 0.76 2.25 1.51 4.5 2.25 6.77 c 1.44 4.32 2.81 8.65 4.14 13 c 0.24 0.75 0.46 1.48 0.69 2.22 c 0.58 1.9 1.14 3.81 1.7 5.71 c 0.69 2.35 1.36 4.7 2.04 7.05 c 1.34 4.7 2.62 9.43 3.86 14.17 c 0.62 2.38 1.22 4.76 1.81 7.13 C 1684.54 830.92 1685.03 832.97 1685.53 835.01 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5 0 0 0.5 73.9175 156.6715)",
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    x: -60.615,
    y: -237.935,
    rx: 0,
    ry: 0,
    width: 121.23,
    height: 475.87
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5 0 0 0.5 73.915 49.4315)",
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    x: -100.11,
    y: -23.455,
    rx: 0,
    ry: 0,
    width: 200.22,
    height: 46.91
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5 0 0 0.5 73.915 263.9115)",
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    x: -100.11,
    y: -23.455,
    rx: 0,
    ry: 0,
    width: 200.22,
    height: 46.91
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5 0 0 0.5 73.915 45.789)",
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    cx: 0,
    cy: 0,
    r: 91.37
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5 0 0 0.5 73.915 45.789)",
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(35,31,32)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    cx: 0,
    cy: 0,
    r: 57.82
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5 0 0 0.5 73.905 308.684)",
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    transform: " translate(-1000.28, -1412.6)",
    d: "M 1100.41 1337.01 c -11.27 -11.89 -24.62 -21.77 -39.5 -29.04 c -6.87 -3.38 -14.07 -6.19 -21.53 -8.37 c -12.4 -3.67 -25.51 -5.63 -39.09 -5.63 s -26.69 1.96 -39.09 5.63 c -7.46 2.2 -14.66 5.01 -21.53 8.39 c -14.87 7.27 -28.24 17.15 -39.5 29.04 c -23.44 24.72 -37.84 58.12 -37.84 94.89 c 0 39 16.18 74.22 42.21 99.31 v -116.21 c 0 -33.64 17.43 -56.42 43.74 -68.51 c 5.39 -2.48 11.14 -4.52 17.19 -6.09 c 10.79 -2.83 22.53 -4.24 34.8 -4.24 s 24.02 1.41 34.81 4.24 c 6.05 1.58 11.8 3.62 17.18 6.09 c 26.31 12.09 43.76 34.87 43.76 68.51 v 116.21 c 26.03 -25.09 42.21 -60.31 42.21 -99.31 C 1138.26 1395.15 1123.88 1361.73 1100.41 1337.01 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5 0 0 0.5 73.92 291.239)",
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    points: "-95.74,37.3 -43.24,-31.2 43.23,-31.2 95.74,37.3 95.74,-37.3 -95.74,-37.3 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5 0 0 0.5 73.92 359.944)",
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    transform: " translate(-1000.31, -1515.12)",
    d: "M 1053.29 1563.92 c 0 29.26 -23.72 52.98 -52.98 52.98 s -52.98 -23.72 -52.98 -52.98 c 0 -29.26 52.98 -150.58 52.98 -150.58 S 1053.29 1534.66 1053.29 1563.92 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5 0 0 0.5 254.75 -122.081)",
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    transform: " translate(-1361.97, -551.07)",
    d: "M 1340.93 596.76 v -14.75 c 0 -11.6 9.44 -21.04 21.04 -21.04 c 11.6 0 21.04 9.44 21.04 21.04 v 14.75 v 12.85 h 20.12 v -12.85 v -14.75 v -89.48 h -20.12 v 54.17 c -6.17 -3.69 -13.35 -5.85 -21.04 -5.85 s -14.87 2.16 -21.04 5.85 v -54.17 h -20.12 v 89.48 v 14.75 v 12.85 h 20.12 V 596.76 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5 0 0 0.5 207.025 -122.046)",
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    transform: " translate(-1266.52, -551.14)",
    d: "M 1280.99 589.64 c -21.23 0 -38.49 -17.27 -38.49 -38.5 c 0 -21.22 17.27 -38.49 38.49 -38.49 c 6 0 11.73 1.34 17.05 3.97 l 8.93 -18.03 c -8.12 -4.02 -16.86 -6.06 -25.98 -6.06 c -32.32 0 -58.61 26.29 -58.61 58.61 c 0 32.32 26.29 58.61 58.61 58.61 c 10.45 0 20.71 -2.79 29.67 -8.06 l -10.2 -17.34 C 1294.58 587.81 1287.85 589.64 1280.99 589.64 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5 0 0 0.5 161.385 -122.0435)",
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    points: "-10.06,-58.615 -36.81,-58.615 -36.81,-38.495 -10.06,-38.495 -10.06,58.615 10.06,58.615 10.06,-38.495 36.81,-38.495 36.81,-58.615 10.06,-58.615 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5 0 0 0.5 106.73 -122.046)",
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    transform: " translate(-1065.93, -551.14)",
    d: "M 1065.93 492.53 c -32.32 0 -58.61 26.29 -58.61 58.61 c 0 32.32 26.29 58.61 58.61 58.61 c 32.32 0 58.61 -26.29 58.61 -58.61 C 1124.54 518.82 1098.25 492.53 1065.93 492.53 z M 1065.93 589.64 c -21.23 0 -38.49 -17.27 -38.49 -38.5 c 0 -21.22 17.27 -38.49 38.49 -38.49 c 21.23 0 38.49 17.27 38.49 38.49 C 1104.43 572.37 1087.16 589.64 1065.93 589.64 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5 0 0 0.5 48.3175 -122.0835)",
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    transform: " translate(-949.105, -551.065)",
    d: "M 949.1 492.53 c -10.44 0 -20.09 3.38 -27.98 9.06 v -9.06 H 901 v 48.1 v 5.4 v 63.57 h 20.12 v -63.57 v -5.4 c 0 -15.43 12.55 -27.99 27.98 -27.99 c 15.43 0 27.99 12.55 27.99 27.99 v 68.97 h 20.12 v -68.97 C 997.2 514.11 975.62 492.53 949.1 492.53 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5 0 0 0.5 -1.4 -122.046)",
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    transform: " translate(-849.67, -551.14)",
    d: "M 849.67 574.85 c 22.69 0 41.16 -18.46 41.16 -41.16 c 0 -22.69 -18.46 -41.16 -41.16 -41.16 c -7.69 0 -14.87 2.16 -21.04 5.85 v -5.85 h -20.12 v 117.22 h 20.12 V 569 C 834.8 572.69 841.98 574.85 849.67 574.85 z M 849.67 512.65 c 11.6 0 21.04 9.44 21.04 21.04 c 0 11.6 -9.44 21.04 -21.04 21.04 c -11.6 0 -21.04 -9.44 -21.04 -21.04 C 828.63 522.09 838.07 512.65 849.67 512.65 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5 0 0 0.5 -56.39 -122.046)",
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    transform: " translate(-739.69, -551.14)",
    d: "M 739.69 492.53 c -32.32 0 -58.61 26.29 -58.61 58.61 c 0 32.32 26.29 58.61 58.61 58.61 c 32.32 0 58.61 -26.29 58.61 -58.61 C 798.3 518.82 772.01 492.53 739.69 492.53 z M 739.69 589.64 c -21.23 0 -38.49 -17.27 -38.49 -38.5 c 0 -21.22 17.27 -38.49 38.49 -38.49 c 21.23 0 38.49 17.27 38.49 38.49 C 778.19 572.37 760.92 589.64 739.69 589.64 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5 0 0 0.5 -109.3925 -122.0435)",
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    points: "-10.065,-58.615 -36.815,-58.615 -36.815,-38.495 -10.065,-38.495 -10.065,58.615 10.055,58.615 10.055,-38.495 36.815,-38.495 36.815,-58.615 10.055,-58.615 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5 0 0 0.5 73.9175 102.384)",
    id: "SVGID_x5F_2_x5F_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    transform: " translate(-1000.305, -1000)",
    d: "M 1679.62 1000 c 0 -375.17 -304.14 -679.31 -679.31 -679.31 S 320.99 624.83 320.99 1000 s 304.14 679.31 679.31 679.31 S 1679.62 1375.18 1679.62 1000 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5 0 0 0.5 -98.6801 -417.979)",
    style: {},
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    fontFamily: "'BelleroseLight'",
    fontSize: 130,
    fontStyle: "normal",
    fontWeight: "normal",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden",
      whiteSpace: "pre"
    }
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: -655.1099,
    y: 40.8382
  }, "Mechanical Services Inc.")))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5 0 0 0.5 73.915 102.3965)",
    id: "Layer_2_copy"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    transform: " translate(-1000.3, -1000.025)",
    d: "M 1704.94 1000 c 0 389.17 -315.47 704.64 -704.64 704.64 S 295.66 1389.17 295.66 1000 c 0 -2.49 0.01 -4.98 0.04 -7.46 v -0.35 c 0.03 -2.52 0.07 -5.04 0.13 -7.54 c 0.04 -2.01 0.08 -4.01 0.15 -6.01 c 0.04 -1.77 0.11 -3.55 0.18 -5.3 c 0 -0.34 0.01 -0.68 0.03 -1 c 0.06 -1.36 0.11 -2.73 0.17 -4.09 c 0.11 -2.53 0.24 -5.07 0.38 -7.6 c 0.07 -1.35 0.15 -2.7 0.24 -4.05 c 0.03 -0.62 0.07 -1.24 0.11 -1.84 c 0.06 -0.89 0.11 -1.76 0.17 -2.63 c 0.13 -1.84 0.25 -3.67 0.39 -5.52 c 0.18 -2.52 0.38 -5.02 0.61 -7.54 c 0.21 -2.5 0.44 -5.01 0.68 -7.51 c 0.18 -1.87 0.37 -3.73 0.56 -5.59 c 0.24 -2.29 0.49 -4.59 0.76 -6.88 c 0.11 -1.03 0.24 -2.05 0.35 -3.08 c 0.27 -2.29 0.56 -4.59 0.86 -6.88 c 0.25 -1.98 0.52 -3.97 0.79 -5.95 c 0.13 -0.9 0.25 -1.79 0.38 -2.67 c 0.28 -2.07 0.59 -4.14 0.9 -6.19 c 0.3 -2 0.61 -4 0.91 -5.98 c 0.55 -3.43 1.13 -6.87 1.73 -10.3 c 0.31 -1.8 0.63 -3.6 0.96 -5.4 c 0.03 -0.18 0.07 -0.35 0.1 -0.55 c 0.44 -2.38 0.89 -4.76 1.35 -7.12 c 0.46 -2.43 0.96 -4.85 1.45 -7.27 c 0.56 -2.76 1.15 -5.52 1.74 -8.27 c 0.45 -2.07 0.91 -4.12 1.38 -6.19 c 0.28 -1.25 0.58 -2.5 0.86 -3.76 h 0.01 c 0.87 -3.78 1.79 -7.57 2.73 -11.34 c 0.53 -2.12 1.08 -4.26 1.63 -6.37 c 1.24 -4.76 2.52 -9.48 3.86 -14.18 c 0.04 -0.15 0.08 -0.31 0.13 -0.46 c 0.63 -2.19 1.27 -4.39 1.91 -6.57 c 0.58 -1.98 1.17 -3.95 1.77 -5.92 c 0.25 -0.87 0.52 -1.73 0.8 -2.6 c 0.55 -1.83 1.13 -3.66 1.7 -5.47 c 0.75 -2.32 1.49 -4.63 2.25 -6.95 c 0.61 -1.86 1.24 -3.73 1.86 -5.59 c 0.27 -0.76 0.53 -1.53 0.79 -2.31 c 0.68 -1.96 1.35 -3.91 2.03 -5.85 c 0.01 -0.01 0.03 -0.04 0.03 -0.06 c 0.8 -2.29 1.63 -4.57 2.45 -6.85 c 0.1 -0.24 0.18 -0.49 0.27 -0.73 v -0.01 c 0.56 -1.51 1.11 -3.01 1.67 -4.5 c 0.2 -0.52 0.39 -1.06 0.59 -1.58 c 0.82 -2.17 1.63 -4.32 2.46 -6.47 c 0.04 -0.11 0.08 -0.21 0.13 -0.31 c 0.87 -2.27 1.76 -4.52 2.66 -6.75 c 0.9 -2.25 1.8 -4.49 2.73 -6.73 c 0.84 -2.04 1.69 -4.08 2.55 -6.12 c 1.03 -2.41 2.07 -4.81 3.11 -7.2 c 0.83 -1.9 1.66 -3.8 2.52 -5.68 c 0.65 -1.46 1.29 -2.93 1.97 -4.38 c 0.77 -1.74 1.58 -3.49 2.41 -5.22 c 0.91 -1.98 1.84 -3.97 2.79 -5.94 c 0.63 -1.35 1.28 -2.69 1.93 -4.02 c 0.55 -1.13 1.1 -2.25 1.65 -3.38 c 0.68 -1.36 1.35 -2.73 2.03 -4.09 c 3.28 -6.57 6.67 -13.09 10.14 -19.54 c 0.73 -1.38 1.48 -2.76 2.24 -4.12 c 0.76 -1.39 1.53 -2.79 2.31 -4.18 c 0.42 -0.77 0.86 -1.55 1.29 -2.32 c 0.84 -1.51 1.7 -3.01 2.56 -4.52 c 3.01 -5.28 6.08 -10.5 9.22 -15.67 c 0.76 -1.25 1.51 -2.49 2.28 -3.73 c 0.7 -1.15 1.41 -2.29 2.12 -3.43 c 1.25 -2.03 2.53 -4.05 3.81 -6.06 c 0.89 -1.39 1.77 -2.79 2.67 -4.16 c 0.37 -0.58 0.73 -1.15 1.11 -1.72 c 1.04 -1.62 2.11 -3.24 3.17 -4.84 c 1.21 -1.83 2.43 -3.64 3.66 -5.46 c 0.77 -1.14 1.53 -2.28 2.32 -3.41 c 1.59 -2.35 3.21 -4.67 4.84 -6.99 c 0.76 -1.1 1.53 -2.2 2.32 -3.28 c 0.2 -0.3 0.41 -0.59 0.62 -0.89 c 1.27 -1.79 2.55 -3.56 3.86 -5.33 c 1.31 -1.83 2.65 -3.64 4 -5.45 c 0.84 -1.15 1.69 -2.29 2.55 -3.43 c 1.2 -1.59 2.39 -3.18 3.62 -4.76 c 1.94 -2.56 3.93 -5.11 5.91 -7.64 c 5.02 -6.39 10.16 -12.69 15.39 -18.9 c 1.74 -2.07 3.5 -4.12 5.28 -6.18 c 129.21 -149.69 320.34 -244.43 533.6 -244.43 s 404.39 94.74 533.62 244.43 c 7.08 8.2 13.97 16.56 20.67 25.09 c 0.39 0.49 0.77 0.98 1.15 1.49 c 1.38 1.74 2.74 3.5 4.08 5.26 c 0.01 0.01 0.03 0.03 0.04 0.04 c 1.49 1.94 2.97 3.9 4.43 5.85 c 2.07 2.74 4.11 5.5 6.12 8.29 c 1.52 2.08 3.03 4.18 4.52 6.28 c 1.27 1.77 2.52 3.56 3.77 5.35 c 0.53 0.76 1.06 1.51 1.58 2.27 c 1.45 2.1 2.88 4.21 4.32 6.33 c 1.34 1.96 2.65 3.93 3.94 5.9 c 0.63 0.96 1.27 1.91 1.89 2.87 c 1.14 1.73 2.27 3.46 3.38 5.21 c 0.08 0.13 0.17 0.25 0.24 0.38 c 1.18 1.83 2.35 3.67 3.5 5.52 c 0.62 0.98 1.24 1.97 1.84 2.97 c 0.38 0.59 0.75 1.18 1.1 1.77 c 0.97 1.55 1.93 3.11 2.87 4.67 c 0.03 0.04 0.06 0.08 0.08 0.14 c 2.48 4.09 4.91 8.2 7.3 12.35 c 0.06 0.07 0.1 0.15 0.14 0.24 c 0.62 1.06 1.21 2.1 1.8 3.15 c 1 1.73 1.98 3.46 2.94 5.19 c 0.13 0.21 0.24 0.41 0.34 0.6 c 1.11 1.97 2.19 3.94 3.26 5.91 c 4.14 7.56 8.12 15.2 11.96 22.91 c 0.94 1.87 1.87 3.76 2.79 5.64 c 0.21 0.42 0.42 0.84 0.62 1.27 c 0.65 1.32 1.28 2.65 1.91 3.98 c 0.68 1.39 1.34 2.79 1.97 4.18 c 0.42 0.87 0.83 1.74 1.24 2.63 c 0.68 1.44 1.34 2.87 1.98 4.32 c 0.56 1.21 1.11 2.43 1.66 3.66 c 0.18 0.38 0.35 0.76 0.51 1.14 c 1.87 4.16 3.69 8.34 5.47 12.54 c 3.77 8.89 7.36 17.87 10.76 26.94 c 0.11 0.3 0.23 0.59 0.32 0.89 c 0.01 0 0.01 0.01 0.01 0.01 c 0.75 1.97 1.46 3.94 2.2 5.92 c 1.65 4.49 3.24 9.01 4.77 13.54 c 0.04 0.13 0.08 0.24 0.13 0.35 c 0.76 2.25 1.51 4.5 2.25 6.77 c 1.44 4.32 2.81 8.65 4.14 13 c 0.24 0.75 0.46 1.48 0.69 2.22 c 0.58 1.9 1.14 3.81 1.7 5.71 c 0.69 2.35 1.36 4.7 2.04 7.05 c 1.34 4.7 2.62 9.43 3.86 14.17 c 0.62 2.38 1.22 4.76 1.81 7.13 c 0.27 1.01 0.52 2.04 0.76 3.07 c 0.25 1.03 0.49 2.05 0.75 3.07 c 0.04 0.17 0.08 0.34 0.11 0.51 c 0.04 0.18 0.08 0.35 0.13 0.52 c 0.58 2.39 1.13 4.78 1.67 7.19 c 0.46 2.05 0.93 4.11 1.38 6.18 c 0.59 2.76 1.18 5.52 1.74 8.29 c 0.49 2.42 0.98 4.84 1.45 7.26 c 0.48 2.43 0.93 4.87 1.38 7.3 c 0.41 2.18 0.79 4.36 1.17 6.56 c 0.49 2.84 0.97 5.68 1.42 8.53 c 0.38 2.32 0.75 4.64 1.08 6.96 c 0.31 2.05 0.62 4.12 0.9 6.19 c 0.13 0.87 0.25 1.73 0.37 2.6 c 0.59 4.29 1.15 8.6 1.66 12.92 c 0.13 1.03 0.24 2.04 0.35 3.07 c 0.27 2.29 0.52 4.59 0.76 6.88 c 0.2 1.86 0.38 3.71 0.56 5.59 c 0.24 2.5 0.46 5.01 0.68 7.51 c 0.23 2.52 0.42 5.02 0.61 7.54 c 0.14 1.84 0.27 3.67 0.39 5.52 c 0.06 0.87 0.11 1.74 0.17 2.63 c 0.04 0.62 0.08 1.22 0.11 1.84 c 0.08 1.35 0.17 2.7 0.24 4.05 c 0.14 2.53 0.27 5.07 0.38 7.6 c 0.06 1.36 0.11 2.73 0.17 4.09 c 0.01 0.32 0.03 0.66 0.03 1 c 0.07 1.76 0.14 3.53 0.18 5.3 c 0.07 2 0.11 4 0.15 6.01 c 0.06 2.5 0.1 5.02 0.13 7.54 v 0.35 C 1704.93 995.02 1704.94 997.51 1704.94 1000 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5 0 0 0.5 73.915 163.504)",
    id: "Layer_2_copy"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    transform: " translate(-1000.3, -1122.24)",
    d: "M 1704.94 1000 c 0 389.17 -315.47 704.64 -704.64 704.64 S 295.66 1389.17 295.66 1000 c 0 -2.49 0.01 -4.98 0.04 -7.46 v -0.35 c 0.03 -2.52 0.07 -5.04 0.13 -7.54 c 0.04 -2.01 0.08 -4.01 0.15 -6.01 c 0.04 -1.77 0.11 -3.55 0.18 -5.3 c 0 -0.34 0.01 -0.68 0.03 -1 c 0.06 -1.36 0.11 -2.73 0.17 -4.09 c 0.11 -2.53 0.24 -5.07 0.38 -7.6 c 0.07 -1.35 0.15 -2.7 0.24 -4.05 c 0.03 -0.62 0.07 -1.24 0.11 -1.84 c 0.06 -0.89 0.11 -1.76 0.17 -2.63 c 0.13 -1.84 0.25 -3.67 0.39 -5.52 c 0.18 -2.52 0.38 -5.02 0.61 -7.54 c 0.21 -2.5 0.44 -5.01 0.68 -7.51 c 0.18 -1.87 0.37 -3.73 0.56 -5.59 c 0.24 -2.29 0.49 -4.59 0.76 -6.88 c 0.11 -1.03 0.24 -2.05 0.35 -3.08 c 0.27 -2.29 0.56 -4.59 0.86 -6.88 c 0.25 -1.98 0.52 -3.97 0.79 -5.95 c 0.13 -0.9 0.25 -1.79 0.38 -2.67 c 0.28 -2.07 0.59 -4.14 0.9 -6.19 c 0.3 -2 0.61 -4 0.91 -5.98 c 0.55 -3.43 1.13 -6.87 1.73 -10.3 c 0.31 -1.8 0.63 -3.6 0.96 -5.4 c 0.03 -0.18 0.07 -0.35 0.1 -0.55 c 0.44 -2.38 0.89 -4.76 1.35 -7.12 c 0.46 -2.43 0.96 -4.85 1.45 -7.27 c 0.56 -2.76 1.15 -5.52 1.74 -8.27 c 0.45 -2.07 0.91 -4.12 1.38 -6.19 c 0.28 -1.25 0.58 -2.5 0.87 -3.76 c 0.87 -3.78 1.79 -7.57 2.73 -11.34 c 0.53 -2.12 1.08 -4.26 1.63 -6.37 c 1.24 -4.76 2.52 -9.48 3.86 -14.18 c 0.04 -0.15 0.08 -0.31 0.13 -0.46 c 0.63 -2.19 1.27 -4.39 1.91 -6.57 c 0.58 -1.98 1.17 -3.95 1.77 -5.92 c 0.25 -0.87 0.52 -1.73 0.8 -2.6 c 0.55 -1.83 1.13 -3.66 1.7 -5.47 c 0.75 -2.32 1.49 -4.63 2.25 -6.95 c 0.61 -1.86 1.24 -3.73 1.86 -5.59 c 0.27 -0.76 0.53 -1.53 0.79 -2.31 c 0.68 -1.96 1.35 -3.91 2.03 -5.85 c 0.01 -0.01 0.03 -0.04 0.03 -0.06 c 0.8 -2.29 1.63 -4.57 2.45 -6.85 c 0.1 -0.24 0.18 -0.49 0.27 -0.73 v -0.01 c 0.56 -1.51 1.11 -3.01 1.67 -4.5 c 0.2 -0.52 0.39 -1.06 0.59 -1.58 c 0.82 -2.17 1.63 -4.32 2.46 -6.47 c 0.04 -0.11 0.08 -0.21 0.13 -0.31 c 0.87 -2.27 1.76 -4.52 2.66 -6.75 c 0.9 -2.25 1.8 -4.49 2.73 -6.73 c 0.84 -2.04 1.69 -4.08 2.55 -6.12 c 1.03 -2.41 2.07 -4.81 3.11 -7.2 c 0.83 -1.9 1.66 -3.8 2.52 -5.68 c 0.65 -1.46 1.29 -2.93 1.97 -4.38 c 0.77 -1.74 1.58 -3.49 2.41 -5.22 c 0.91 -1.98 1.84 -3.97 2.79 -5.94 c 0.63 -1.35 1.28 -2.69 1.93 -4.02 c 0.55 -1.13 1.1 -2.25 1.65 -3.38 c 0.68 -1.36 1.35 -2.73 2.03 -4.09 c 3.28 -6.57 6.67 -13.09 10.14 -19.54 c 0.73 -1.38 1.48 -2.76 2.24 -4.12 c 0.76 -1.39 1.53 -2.79 2.31 -4.18 c 0.42 -0.77 0.86 -1.55 1.29 -2.32 c 0.84 -1.51 1.7 -3.01 2.56 -4.52 c 3.01 -5.28 6.08 -10.5 9.22 -15.67 c 0.76 -1.25 1.51 -2.49 2.28 -3.73 c 0.7 -1.15 1.41 -2.29 2.12 -3.43 c 1.25 -2.03 2.53 -4.05 3.81 -6.06 c 0.89 -1.39 1.77 -2.79 2.67 -4.16 c 0.37 -0.58 0.73 -1.15 1.11 -1.72 c 1.04 -1.62 2.11 -3.24 3.17 -4.84 c 1.21 -1.83 2.43 -3.64 3.66 -5.46 c 0.77 -1.14 1.53 -2.28 2.32 -3.41 c 1.59 -2.35 3.21 -4.67 4.84 -6.99 c 0.76 -1.1 1.53 -2.2 2.32 -3.28 c 0.2 -0.3 0.41 -0.59 0.62 -0.89 c 1.27 -1.79 2.55 -3.56 3.86 -5.33 c 1.31 -1.83 2.65 -3.64 4 -5.45 c 0.84 -1.15 1.69 -2.29 2.55 -3.43 c 1.2 -1.59 2.39 -3.18 3.62 -4.76 c 1.94 -2.56 3.93 -5.11 5.91 -7.64 c 5.02 -6.39 10.16 -12.69 15.39 -18.9 c 1.74 -2.07 3.5 -4.12 5.28 -6.18 c 62.28 60.81 130.95 108.47 204.37 143.53 c 10.55 5.04 21.2 9.82 31.95 14.34 c 83.58 35.33 172.05 54.56 261.37 58.81 c 11.96 0.56 23.93 0.87 35.91 0.9 c 9.01 -0.03 18 -0.2 26.99 -0.52 h 0.01 c 92.34 -3.36 183.91 -22.7 270.28 -59.19 c 13.65 -5.74 27.16 -11.9 40.49 -18.49 c 70.21 -34.63 135.99 -80.93 195.84 -139.38 c 7.08 8.2 13.97 16.56 20.67 25.09 c 0.39 0.49 0.77 0.98 1.15 1.49 c 1.38 1.74 2.74 3.5 4.08 5.26 c 0.01 0.01 0.03 0.03 0.04 0.04 c 1.49 1.94 2.97 3.9 4.43 5.85 c 2.07 2.74 4.11 5.5 6.12 8.29 c 1.52 2.08 3.03 4.18 4.52 6.28 c 1.27 1.77 2.52 3.56 3.77 5.35 c 0.53 0.76 1.06 1.51 1.58 2.27 c 1.45 2.1 2.88 4.21 4.32 6.33 c 1.34 1.96 2.65 3.93 3.94 5.9 c 0.63 0.96 1.27 1.91 1.89 2.87 c 1.14 1.73 2.27 3.46 3.38 5.21 c 0.08 0.13 0.17 0.25 0.24 0.38 c 1.18 1.83 2.35 3.67 3.5 5.52 c 0.62 0.98 1.24 1.97 1.84 2.97 c 0.38 0.59 0.75 1.18 1.1 1.77 c 0.97 1.55 1.93 3.11 2.87 4.67 c 0.03 0.04 0.06 0.08 0.08 0.14 c 2.48 4.09 4.91 8.2 7.3 12.35 c 0.06 0.07 0.1 0.15 0.14 0.24 c 0.62 1.06 1.21 2.1 1.8 3.15 c 1 1.73 1.98 3.46 2.94 5.19 c 0.13 0.21 0.24 0.41 0.34 0.6 c 1.11 1.97 2.19 3.94 3.26 5.91 c 4.14 7.56 8.12 15.2 11.96 22.91 c 0.94 1.87 1.87 3.76 2.79 5.64 c 0.21 0.42 0.42 0.84 0.62 1.27 c 0.65 1.32 1.28 2.65 1.91 3.98 c 0.68 1.39 1.34 2.79 1.97 4.18 c 0.42 0.87 0.83 1.74 1.24 2.63 c 0.68 1.44 1.34 2.87 1.98 4.32 c 0.56 1.21 1.11 2.43 1.66 3.66 c 0.18 0.38 0.35 0.76 0.51 1.14 c 1.87 4.16 3.69 8.34 5.47 12.54 c 3.77 8.89 7.36 17.87 10.76 26.94 c 0.11 0.3 0.23 0.59 0.32 0.89 c 0.01 0 0.01 0.01 0.01 0.01 c 0.75 1.97 1.46 3.94 2.2 5.92 c 1.63 4.49 3.22 9.01 4.77 13.54 c 0.04 0.13 0.08 0.24 0.13 0.35 c 0.76 2.25 1.51 4.5 2.25 6.77 c 1.42 4.32 2.8 8.65 4.14 13 c 0.24 0.75 0.46 1.48 0.69 2.22 c 0.58 1.9 1.14 3.81 1.7 5.71 c 0.69 2.35 1.36 4.7 2.04 7.05 c 1.34 4.7 2.62 9.43 3.86 14.17 c 0.62 2.38 1.22 4.76 1.81 7.13 c 0.27 1.01 0.52 2.04 0.76 3.07 c 0.24 1.01 0.49 2.04 0.73 3.07 c 0.04 0.17 0.1 0.34 0.13 0.51 c 0.04 0.18 0.08 0.35 0.13 0.52 c 0.58 2.39 1.13 4.78 1.67 7.19 c 0.46 2.05 0.93 4.11 1.38 6.18 c 0.59 2.76 1.18 5.52 1.74 8.29 c 0.49 2.42 0.98 4.84 1.45 7.26 c 0.48 2.43 0.93 4.87 1.38 7.3 c 0.41 2.18 0.79 4.36 1.17 6.56 c 0.49 2.84 0.97 5.68 1.42 8.53 c 0.38 2.32 0.75 4.64 1.08 6.96 c 0.31 2.05 0.62 4.12 0.9 6.19 c 0.13 0.87 0.25 1.73 0.37 2.6 c 0.59 4.29 1.15 8.6 1.66 12.92 c 0.13 1.03 0.24 2.04 0.35 3.07 c 0.27 2.29 0.52 4.59 0.76 6.88 c 0.2 1.86 0.38 3.71 0.56 5.59 c 0.24 2.5 0.46 5.01 0.68 7.51 c 0.23 2.52 0.42 5.02 0.61 7.54 c 0.14 1.84 0.27 3.67 0.39 5.52 c 0.06 0.87 0.11 1.74 0.17 2.63 c 0.04 0.62 0.08 1.22 0.11 1.84 c 0.08 1.35 0.17 2.7 0.24 4.05 c 0.14 2.53 0.27 5.07 0.38 7.6 c 0.06 1.36 0.11 2.73 0.17 4.09 c 0.01 0.32 0.03 0.66 0.03 1 c 0.07 1.76 0.14 3.53 0.18 5.3 c 0.07 2 0.11 4 0.15 6.01 c 0.06 2.5 0.1 5.02 0.13 7.54 v 0.35 C 1704.93 995.02 1704.94 997.51 1704.94 1000 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5 0 0 0.5 -47.7675 19.8107)",
    id: "Layer_2_copy"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(35,31,32)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    transform: " translate(-756.935, -834.8534)",
    d: "M 1199.86 853.84 c -4.22 1.21 -8.43 2.45 -12.64 3.71 c -2.1 0.62 -4.19 1.27 -6.29 1.91 c -2.1 0.63 -4.19 1.28 -6.28 1.94 c -2.1 0.66 -4.19 1.32 -6.28 2 c -2.08 0.66 -4.16 1.34 -6.25 2.03 c -6.46 2.12 -12.89 4.31 -19.3 6.54 c -1.73 0.61 -3.46 1.21 -5.18 1.83 c -0.24 0.08 -0.48 0.17 -0.72 0.25 c -1.96 0.69 -3.9 1.39 -5.85 2.11 c -2.05 0.75 -4.12 1.51 -6.18 2.27 c -4.11 1.52 -8.19 3.07 -12.27 4.64 c -4.09 1.56 -8.16 3.17 -12.23 4.8 c -2.95 1.17 -5.91 2.36 -8.85 3.57 c -2.93 1.2 -5.85 2.41 -8.77 3.63 v 91.32 c -7.25 -4.7 -14.53 -9.3 -21.88 -13.82 c -4.29 -2.65 -8.58 -5.25 -12.9 -7.84 c -3.57 -2.12 -7.15 -4.22 -10.74 -6.32 c -8.79 -5.05 -17.64 -9.96 -26.56 -14.75 c -4.81 -2.59 -9.64 -5.14 -14.48 -7.64 c -12.35 -6.4 -24.82 -12.58 -37.41 -18.49 c -3.36 -1.59 -6.74 -3.15 -10.13 -4.7 c -3 -1.38 -5.99 -2.73 -9.01 -4.07 c -7.26 -3.25 -14.55 -6.42 -21.88 -9.48 c -2.41 -1.01 -4.83 -2.01 -7.25 -3.01 c -0.39 -0.15 -0.79 -0.32 -1.18 -0.48 c -3.05 -1.27 -6.12 -2.5 -9.19 -3.71 c -2.2 -0.89 -4.4 -1.76 -6.61 -2.62 c -2.21 -0.86 -4.42 -1.72 -6.63 -2.56 c -4.26 -1.65 -8.54 -3.26 -12.83 -4.83 c -2.48 -0.91 -4.95 -1.82 -7.43 -2.72 c -2.14 -0.77 -4.29 -1.55 -6.44 -2.29 c -4.47 -1.59 -8.96 -3.14 -13.45 -4.64 c -2.25 -0.77 -4.5 -1.52 -6.75 -2.25 c -2.25 -0.75 -4.5 -1.49 -6.77 -2.21 c -1.66 -0.55 -3.33 -1.07 -4.99 -1.59 c -3.1 -1 -6.2 -1.96 -9.33 -2.91 c -2 -0.62 -4.01 -1.22 -6.02 -1.83 c -0.04 -0.01 -0.07 -0.03 -0.1 -0.03 c -2.27 -0.68 -4.53 -1.35 -6.8 -2.01 c -2.28 -0.68 -4.57 -1.34 -6.85 -1.98 s -4.57 -1.29 -6.87 -1.93 c -47.66 -13.21 -96.42 -23.03 -146.05 -29.2 c -108.12 -13.62 -219.37 -9.88 -332.23 12.96 c 0.87 -3.78 1.79 -7.57 2.73 -11.34 c 0.53 -2.12 1.08 -4.26 1.63 -6.37 c 1.24 -4.76 2.52 -9.48 3.86 -14.18 c 0.04 -0.15 0.08 -0.31 0.13 -0.46 c 0.63 -2.19 1.27 -4.39 1.91 -6.57 c 0.58 -1.98 1.17 -3.95 1.77 -5.92 c 0.25 -0.87 0.52 -1.73 0.8 -2.6 c 0.55 -1.83 1.13 -3.66 1.7 -5.47 c 0.75 -2.32 1.49 -4.63 2.25 -6.95 c 0.61 -1.86 1.24 -3.73 1.86 -5.59 c 0.27 -0.76 0.53 -1.53 0.79 -2.31 c 0.68 -1.96 1.35 -3.91 2.03 -5.85 c 0.01 -0.01 0.03 -0.04 0.03 -0.06 c 0.8 -2.29 1.63 -4.57 2.45 -6.85 c 0.1 -0.24 0.18 -0.49 0.27 -0.73 v -0.01 c 96.03 -46.83 205.03 -71.67 314.08 -74.54 c 6.25 -0.18 12.51 -0.28 18.76 -0.31 c 110.03 -0.62 220.47 20.64 323.81 60.36 c 10.89 4.18 21.68 8.57 32.4 13.17 h 0.01 c 33.63 14.38 66.41 30.76 98.06 49.01 C 1150.92 820.63 1175.8 836.67 1199.86 853.84 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5 0 0 0.5 193.225 17.6876)",
    id: "Layer_2_copy"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(35,31,32)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    transform: " translate(-1238.92, -830.6074)",
    d: "M 1685.53 835.01 c 0 -0.01 -0.01 0 -0.01 0 c -112.49 -22.65 -223.39 -26.33 -331.17 -12.75 c -52.55 6.53 -104.16 17.17 -154.48 31.57 c -33.75 9.67 -66.95 21.05 -99.45 34.04 c -2.95 1.17 -5.91 2.36 -8.85 3.57 c -2.93 1.2 -5.85 2.41 -8.77 3.63 c -7.33 3.08 -14.63 6.23 -21.88 9.47 c -2.22 0.98 -4.45 1.98 -6.66 3 c -7.18 3.25 -14.32 6.58 -21.42 10 c -12.33 5.92 -24.52 12.09 -36.61 18.49 c -3.95 2.1 -7.89 4.21 -11.83 6.36 c -7.06 3.84 -14.08 7.75 -21.08 11.76 c -4.74 2.76 -9.46 5.56 -14.15 8.39 c -3.17 1.9 -6.33 3.83 -9.48 5.77 c -7.34 4.52 -14.65 9.13 -21.88 13.83 V 899.3 c -2.8 -1.18 -5.61 -2.34 -8.43 -3.49 c -3.05 -1.27 -6.12 -2.5 -9.19 -3.71 c -35.22 -14.06 -71.21 -26.23 -107.88 -36.4 c 26.68 -19.49 54.4 -37.57 82.94 -54.07 c 28.84 -16.63 58.63 -31.71 89.14 -45.15 c 10.09 -4.45 20.25 -8.71 30.49 -12.79 c 109.12 -43.53 226.48 -66.37 343.19 -64.51 c 3.4 0.04 6.81 0.11 10.22 0.21 c 108.31 2.86 216.58 27.38 312.14 73.62 c 0.01 0 0.01 0.01 0.01 0.01 c 0.75 1.97 1.46 3.94 2.2 5.92 c 1.65 4.49 3.24 9.01 4.77 13.54 c 0.04 0.13 0.08 0.24 0.13 0.35 c 0.76 2.25 1.51 4.5 2.25 6.77 c 1.44 4.32 2.81 8.65 4.14 13 c 0.24 0.75 0.46 1.48 0.69 2.22 c 0.58 1.9 1.14 3.81 1.7 5.71 c 0.69 2.35 1.36 4.7 2.04 7.05 c 1.34 4.7 2.62 9.43 3.86 14.17 c 0.62 2.38 1.22 4.76 1.81 7.13 C 1684.54 830.92 1685.03 832.97 1685.53 835.01 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5 0 0 0.5 73.9175 156.6715)",
    id: "Layer_2_copy"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(35,31,32)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    x: -60.615,
    y: -237.935,
    rx: 0,
    ry: 0,
    width: 121.23,
    height: 475.87
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5 0 0 0.5 73.915 49.4315)",
    id: "Layer_2_copy"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(35,31,32)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    x: -100.11,
    y: -23.455,
    rx: 0,
    ry: 0,
    width: 200.22,
    height: 46.91
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5 0 0 0.5 73.915 263.9115)",
    id: "Layer_2_copy"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(35,31,32)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    x: -100.11,
    y: -23.455,
    rx: 0,
    ry: 0,
    width: 200.22,
    height: 46.91
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5 0 0 0.5 73.915 45.789)",
    id: "Layer_2_copy"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(35,31,32)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    cx: 0,
    cy: 0,
    r: 91.37
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5 0 0 0.5 73.915 45.789)",
    id: "Layer_2_copy"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    cx: 0,
    cy: 0,
    r: 57.82
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5 0 0 0.5 73.905 308.684)",
    id: "Layer_2_copy"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(35,31,32)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    transform: " translate(-1000.28, -1412.6)",
    d: "M 1100.41 1337.01 c -11.27 -11.89 -24.62 -21.77 -39.5 -29.04 c -6.87 -3.38 -14.07 -6.19 -21.53 -8.37 c -12.4 -3.67 -25.51 -5.63 -39.09 -5.63 s -26.69 1.96 -39.09 5.63 c -7.46 2.2 -14.66 5.01 -21.53 8.39 c -14.87 7.27 -28.24 17.15 -39.5 29.04 c -23.44 24.72 -37.84 58.12 -37.84 94.89 c 0 39 16.18 74.22 42.21 99.31 v -116.21 c 0 -33.64 17.43 -56.42 43.74 -68.51 c 5.39 -2.48 11.14 -4.52 17.19 -6.09 c 10.79 -2.83 22.53 -4.24 34.8 -4.24 s 24.02 1.41 34.81 4.24 c 6.05 1.58 11.8 3.62 17.18 6.09 c 26.31 12.09 43.76 34.87 43.76 68.51 v 116.21 c 26.03 -25.09 42.21 -60.31 42.21 -99.31 C 1138.26 1395.15 1123.88 1361.73 1100.41 1337.01 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5 0 0 0.5 73.92 291.239)",
    id: "Layer_2_copy"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(35,31,32)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    points: "-95.74,37.3 -43.24,-31.2 43.23,-31.2 95.74,37.3 95.74,-37.3 -95.74,-37.3 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5 0 0 0.5 73.92 359.944)",
    id: "Layer_2_copy"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    transform: " translate(-1000.31, -1515.12)",
    d: "M 1053.29 1563.92 c 0 29.26 -23.72 52.98 -52.98 52.98 s -52.98 -23.72 -52.98 -52.98 c 0 -29.26 52.98 -150.58 52.98 -150.58 S 1053.29 1534.66 1053.29 1563.92 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5 0 0 0.5 254.75 -122.081)",
    id: "Layer_2_copy"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(35,31,32)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    transform: " translate(-1361.97, -551.07)",
    d: "M 1340.93 596.76 v -14.75 c 0 -11.6 9.44 -21.04 21.04 -21.04 c 11.6 0 21.04 9.44 21.04 21.04 v 14.75 v 12.85 h 20.12 v -12.85 v -14.75 v -89.48 h -20.12 v 54.17 c -6.17 -3.69 -13.35 -5.85 -21.04 -5.85 s -14.87 2.16 -21.04 5.85 v -54.17 h -20.12 v 89.48 v 14.75 v 12.85 h 20.12 V 596.76 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5 0 0 0.5 207.025 -122.046)",
    id: "Layer_2_copy"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(35,31,32)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    transform: " translate(-1266.52, -551.14)",
    d: "M 1280.99 589.64 c -21.23 0 -38.49 -17.27 -38.49 -38.5 c 0 -21.22 17.27 -38.49 38.49 -38.49 c 6 0 11.73 1.34 17.05 3.97 l 8.93 -18.03 c -8.12 -4.02 -16.86 -6.06 -25.98 -6.06 c -32.32 0 -58.61 26.29 -58.61 58.61 c 0 32.32 26.29 58.61 58.61 58.61 c 10.45 0 20.71 -2.79 29.67 -8.06 l -10.2 -17.34 C 1294.58 587.81 1287.85 589.64 1280.99 589.64 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5 0 0 0.5 161.385 -122.0435)",
    id: "Layer_2_copy"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(35,31,32)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    points: "-10.06,-58.615 -36.81,-58.615 -36.81,-38.495 -10.06,-38.495 -10.06,58.615 10.06,58.615 10.06,-38.495 36.81,-38.495 36.81,-58.615 10.06,-58.615 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5 0 0 0.5 106.73 -122.046)",
    id: "Layer_2_copy"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(35,31,32)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    transform: " translate(-1065.93, -551.14)",
    d: "M 1065.93 492.53 c -32.32 0 -58.61 26.29 -58.61 58.61 c 0 32.32 26.29 58.61 58.61 58.61 c 32.32 0 58.61 -26.29 58.61 -58.61 C 1124.54 518.82 1098.25 492.53 1065.93 492.53 z M 1065.93 589.64 c -21.23 0 -38.49 -17.27 -38.49 -38.5 c 0 -21.22 17.27 -38.49 38.49 -38.49 c 21.23 0 38.49 17.27 38.49 38.49 C 1104.43 572.37 1087.16 589.64 1065.93 589.64 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5 0 0 0.5 48.3175 -122.0835)",
    id: "Layer_2_copy"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(35,31,32)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    transform: " translate(-949.105, -551.065)",
    d: "M 949.1 492.53 c -10.44 0 -20.09 3.38 -27.98 9.06 v -9.06 H 901 v 48.1 v 5.4 v 63.57 h 20.12 v -63.57 v -5.4 c 0 -15.43 12.55 -27.99 27.98 -27.99 c 15.43 0 27.99 12.55 27.99 27.99 v 68.97 h 20.12 v -68.97 C 997.2 514.11 975.62 492.53 949.1 492.53 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5 0 0 0.5 -1.4 -122.046)",
    id: "Layer_2_copy"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(35,31,32)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    transform: " translate(-849.67, -551.14)",
    d: "M 849.67 574.85 c 22.69 0 41.16 -18.46 41.16 -41.16 c 0 -22.69 -18.46 -41.16 -41.16 -41.16 c -7.69 0 -14.87 2.16 -21.04 5.85 v -5.85 h -20.12 v 117.22 h 20.12 V 569 C 834.8 572.69 841.98 574.85 849.67 574.85 z M 849.67 512.65 c 11.6 0 21.04 9.44 21.04 21.04 c 0 11.6 -9.44 21.04 -21.04 21.04 c -11.6 0 -21.04 -9.44 -21.04 -21.04 C 828.63 522.09 838.07 512.65 849.67 512.65 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5 0 0 0.5 -56.39 -122.046)",
    id: "Layer_2_copy"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(35,31,32)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    transform: " translate(-739.69, -551.14)",
    d: "M 739.69 492.53 c -32.32 0 -58.61 26.29 -58.61 58.61 c 0 32.32 26.29 58.61 58.61 58.61 c 32.32 0 58.61 -26.29 58.61 -58.61 C 798.3 518.82 772.01 492.53 739.69 492.53 z M 739.69 589.64 c -21.23 0 -38.49 -17.27 -38.49 -38.5 c 0 -21.22 17.27 -38.49 38.49 -38.49 c 21.23 0 38.49 17.27 38.49 38.49 C 778.19 572.37 760.92 589.64 739.69 589.64 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5 0 0 0.5 -109.3925 -122.0435)",
    id: "Layer_2_copy"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(35,31,32)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    points: "-10.065,-58.615 -36.815,-58.615 -36.815,-38.495 -10.065,-38.495 -10.065,58.615 10.055,58.615 10.055,-38.495 36.815,-38.495 36.815,-58.615 10.055,-58.615 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5 0 0 0.5 73.9175 102.384)",
    id: "SVGID_x5F_3_x5F_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    transform: " translate(-1000.305, -1000)",
    d: "M 1679.62 1000 c 0 -375.17 -304.14 -679.31 -679.31 -679.31 S 320.99 624.83 320.99 1000 s 304.14 679.31 679.31 679.31 S 1679.62 1375.18 1679.62 1000 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5 0 0 0.5 -98.6801 -417.979)",
    style: {},
    id: "Layer_2_copy"
  }, /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    fontFamily: "'BelleroseLight'",
    fontSize: 130,
    fontStyle: "normal",
    fontWeight: "normal",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(35,31,32)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden",
      whiteSpace: "pre"
    }
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: -655.1099,
    y: 40.8382
  }, "Mechanical Services Inc.")))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUntitled);
export default __webpack_public_path__ + "static/media/Untitled.3323331d7986c5a93a614477e89a5f36.svg";
export { ForwardRef as ReactComponent };